// Core imports
import * as React from 'react';
import * as moment from 'moment';
import WarrantyClaimService from 'src/services/warrantyClaim/warrantyClaimService';
import env from 'src/shared/env';
import { IAddress, addressUSA, addressCA } from './warrantyStatesAddress';
import { ILocation, locationUSA, locationCA } from './WarrantyLocationAddress';
import { useRef } from 'react';

// Components imports
import DateSingle from 'src/components/common/DateSingle';
import i18n from 'src/translation/i18n';
import Select from 'react-select';
import { HalfCircleSpinner } from 'react-epic-spinners';
import { Tooltip } from '@material-ui/core';
import AlertMessage from './AlertMessage';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles
} from '@material-ui/core/styles';
import CustomSelect from 'react-select';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { DropzoneAreaBase } from 'material-ui-dropzone';

// utils regex
import {
  MustbNumericRegEx,
  UsphoneNumberRegEx,
  AlphaNumericRegex,
  AlphaNumerictrackinglocationRegex,
  AlphaNumericspaceRegex,
  PostalCodeRegEx,
  emailcapsRegEx,
  commentsRegEx,
  NonkeycharacterRegEx,
  AplhanumerichypenRegEx,
  PostalCodeCARegex
} from 'src/utils/RegexUtils';

// Style and misc imports
import './WarrantyClaimForm.scss';
import { any, element } from 'prop-types';
import UserModel from 'src/model/user.model';
import ServiceInfofields from './ServiceInformation/serviceInfofields';
import ClaimStatusModel from 'src/model/ClaimStatus.model';
import CSPFailedDetails from 'src/model/CSPFailedDetails.model';
import ClaimPartDetails from 'src/model/ClaimPartDetails.model';

class WarrantyClaimForm extends React.Component<
  IWarrantyClaimFormProps,
  IWarrantyClaimFormState
> {
  public uploadQueue: any[] = [];
  public deletepic: any[] = [];
  public selectRef: any = null;
  constructor(props: IWarrantyClaimFormProps) {
    super(props);
    this.state = {
      formData: {
        accountNumber: this.props?.userData?.accountId
          ? this.props.userData.accountId
          : '',
        accountName: '',
        brand: '',
        claimNumber: '', // number
        partNumber: '', //  strt mine
        customerNumber: '',
        servicePerformed: '',
        orginvoiceNumber: '',
        replacementInvNo: '',
        partprice: '',
        quantity: '',
        haveureturnpart: '',
        trackingnum: '',
        trackinglocation: '',
        refno: '',
        incidentNumber: '',
        purchasecost: '',
        picofpart: '',
        reset: false,
        modellist: false,
        reqreturn: '',
        producttype: '',
        supplierinvnum: '',
        supplierordernum: '',
        supplierponum: '',
        stateCode: '',
        picurl: '',
        errormsg: '',
        errormsgshow: false,
        ModelnumberList: [],
        ModelnumberSelected: [
          {
            value: 'Model Number',
            label: 'Model Number'
          }
        ],
        // end mine
        customer: {
          address: '',
          city: '',
          country: env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'Canada' : 'USA',
          firstName: '',
          number: '',
          lastName: '',
          phone: '',
          servicerEmail: '',
          servicerPhone: '',
          postalcode: '', // mine
          email: '', // mine
          state: '',
          zipCode: ''
        },
        customerComplaint: '',
        modelNumber: '',
        partInstalledDate: null,
        partcallReceivedDate: null,
        partFailedDate: null,
        partRepairDate: null,
        partPurchaseDate: null,
        partsupplierinvdate: null,
        serialNumber: '',
        warrantyClaimDetails: [{ ...this.partBase }],
        showUploadModal: false,
        uploadsuccess: true,
        otherstate: false,
        finalsubmit: false,
        picloading: false,
        picfailed: false
      },
      image: {
        open: false,
        files: []
      },
      component: {
        formValidated: false,
        fieldsFailed: []
      },
      brandMapingList: [],
      fieldsForSelectedBrand: {},
      brandSelect: [],
      selectedState:
        env.REACT_APP_BASE_ENVIRONMENT === 'CA'
          ? { name: ' ', value: '' }
          : { name: ' ', value: '' },
      selectedreturntag: yesno[0],
      selectedhavureturn: yesno[0],
      selectedproducttag: productList[0],
      selectedtrackinglocation:
        env.REACT_APP_BASE_ENVIRONMENT === 'CA'
          ? locationCA[0]
          : locationUSA[0],
      selectedBrand: null,
      errors: {
        supplierinvnumInvalidError: false,
        supplierordernumInvalidError: false,
        servicerEmailError: false,
        ReturnpartinvalidError: false,
        trackinglocationInvalidError: false,
        customerPhoneError: false,
        partInstalledDateError: false,
        partcallReceivedDateError: false,
        partFailDateError: false,
        partsDetailsInvalidList: [this.partError],
        incidentNumberInvalidError: false,
        accountNumberInvalidError: false,
        customerComplaintInvalidError: false,
        customerNumberError: false, //  start mine
        purchasecostInvalidError: false,
        picofpartInvalidError: false,
        claimNumberInvalidError: false,
        consumerprovinceError: false,
        partNumberInvalidError: false,
        modelNumberInvalidError: false,
        serialNumberInvalidError: false,
        servicePerformedInvalidError: false,
        customerFirstNameInvalidError: false,
        customerLastNameInvalidError: false,
        orginvoiceNumberInvalidError: false,
        RepinvNumberInvalidError: false,
        consumerEmailError: false,
        consumerpostalcodeInvalidError: false,
        partpriceInvalidError: false,
        partRepairDateError: false,
        trackingNumberInvalidError: false,
        partPurchaseDateError: false,
        quantityInvalidError: false,
        refnoInvalidError: false,
        supplierpoInvalidError: false,
        stateInvaliderror: false,
        reqforreturnInvalidError: false,
        servicerphoneError: false,
        customeraddressInvalidError: false,
        customercityInvalidError: false,
        customerstateInvalidError: false,
        haveureturnInvalidError: false,
        reqreturnInvalidError: false,
        producttypeInvalidError: false
      },
      isSubmitButtonDisabled: false,
      claimType:'partFailedAfterInstall'
    };
  }
  private partError = {
    partNumberInvalidError: false,
    quantityInvalidError: false,
    partpriceInvalidError: false,
    RepinvNumberInvalidError: false,
    orginvoiceNumberInvalidError: false
  };

  private partBase = {
    partNumber: '',
    quantity: 0,
    price: 0,
    totalprice: '',
    unitprice: '',
    unitpricenum: 0,
    replacementInvNo: '',
    invoiceNumber: 0,
    orgpurchasedate: '',
    tempquantity: 1,
    quantityshow: '',
    priceshow: '',
    imgfail: '',
    testpartnum: '',
    imagetype: false,
    funentrycount: 0,
    partReplacementDate: moment(null),
    spinner: false,
    loadingerror: false,
    count: 0,
    picofpart: [''],
    fileArray: [''],
    tempfilearray: [''],
    uploadedfile: [''],
    imagepreview: [''],
    indexImage: 0,
    showUploadModal: false,
    deletepic: false,
    mfg: '',
    wholePartNumber: '',
    open: false,
    maxsize: false,

    fileobject: [''],
    pictureofparts: [
      {
        filename: '',
        spinner: '',
        file: [''],
        imagecount: 0,
        imgfail: '',
        imgthumbnail: ''
      }
    ],
    pictureofpartstemp: [
      {
        filename: '',
        spinner: '',
        file: [''],
        imagecount: 0,
        imgfail: '',
        imgthumbnail: ''
      }
    ],
    partSelectedDetails: [
      {
        invoiceNumber: 'Select Invoice',
        partNumber: '',
        availableQuantity: 0,
        unitPrice: 0,
        purchaseDate: '',
        manufacturerCode: '',
        invoiceDate: '',
        wholePartNumber: ''
      }
    ],
    Invoiceoption: {},
    partInvoiceList: [
      {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice',
        isDisabled: false,
        wholePartNumber: ''
      }
    ],
    partInvoiceListtemp: [
      {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice'
      }
    ],
    partInvoiceShow: [
      {
        value: 'Select Invoice',
        label: 'Select Invoice'
      }
    ]
  };

  public getDateFormat = (date: any) => {
    if (date) {
      const year = date.substring(0, 4);
      const month = date.substring(4, 6);
      const day = date.substring(6, 8);
      return month + '/' + day + '/' + year;
    }
    return '-';
  };
  public getAmountFixedValue = (amount: any) => {
    const amountVal = Number(amount);
    if (amountVal) {
      return `$${amountVal.toFixed(2)}`;
    }
    return '0';
  };
  public SetResubmitClaimDetails = (bmList: any) => {
    const formData: any = { ...this.state.formData };
    formData.claimNumber = this.props.claimNumber;
    // debugger;
    this.setState({
      formData: {
        ...this.state.formData
      }
    });
    const sltBrand: IBrand = {
      value: this.props.RSClaimDetails.manufacturerCode,
      label: this.props.RSClaimDetails.manufacturerCode
    };

    // this.onBrandSelected(sltBrand);
    const brandMapingList: any[] = this.state.brandMapingList;

    const selectBrandField: any[] = brandMapingList.filter(
      a =>
        (a['acf']['brand'] + '').toLowerCase() ===
        (sltBrand.value + '').toLowerCase()
    );
    if (selectBrandField.length > 0) {
      this.setState({ fieldsForSelectedBrand: selectBrandField[0]['acf'] });
    } else {
      this.setState({ fieldsForSelectedBrand: {} });
    }

    this.setState({ selectedBrand: sltBrand }, () => {
      const data = {
        target: { ...this.state.selectedBrand, name: 'brand' }
      };
      this.handleDataSetting(data);
    });

    this.setState({
      formData: {
        ...this.state.formData,
        brand: this.props.RSClaimDetails.manufacturerCode
      }
    });

    const brandSelect: any[] = [];
    brandSelect.push(sltBrand);
    this.setState({ brandSelect });

    const mdlSelected: IModellist[] = [];
    mdlSelected.push({
      value: this.props.RSClaimDetails.modelNumber,
      label: this.props.RSClaimDetails.modelNumber
    });
    this.setState({
      formData: {
        ...this.state.formData,
        ModelnumberSelected: mdlSelected
      }
    });
    const custDetails = this.props.RSClaimDetails.partsClaimCustomerDetailV1;
    this.setState({
      formData: {
        ...this.state.formData,
        servicePerformed: this.props.RSClaimDetails.servicePerformed,
        warrantyClaimDetails: [{ ...this.partBase }],
        stateCode: custDetails.state,
        customer: {
          address: custDetails.address,
          city: custDetails.city,
          country: env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'Canada' : 'USA',
          firstName: custDetails.firstName,
          number: custDetails.phone,
          lastName: custDetails.lastName,
          phone: custDetails.phone,
          servicerEmail: this.props.RSClaimDetails.servicerEmail,
          servicerPhone: this.props.RSClaimDetails.servicerPhoneNumber,
          postalcode: custDetails.zipCode, // mine
          email: custDetails.email ? custDetails.email : '', // mine
          state: custDetails.state,
          zipCode: custDetails.zipCode
        },
        customerComplaint: this.props.RSClaimDetails.customerComplaint,
        modelNumber: this.props.RSClaimDetails.modelNumber,
        refno: this.props.RSClaimDetails.yourReferenceNumber,
        serialNumber: this.props.RSClaimDetails.serialNumber,
        partInstalledDate: moment(
          this.getDateFormat(this.props.RSClaimDetails.installDate)
        ),
        partcallReceivedDate: moment(
          this.getDateFormat(this.props.RSClaimDetails.repairDate)
        ),
        partFailedDate: moment(
          this.getDateFormat(this.props.RSClaimDetails.failureDate)
        ),
        partRepairDate: moment(
          this.getDateFormat(this.props.RSClaimDetails.repairDate)
        ),
        partPurchaseDate: moment(
          this.getDateFormat(this.props.RSClaimDetails.repairDate)
        ),
        partsupplierinvdate: moment(
          this.getDateFormat(this.props.RSClaimDetails.repairDate)
        )
      }
    });

    const pDetails = this.props.RSClaimDetails.partNumber.split(' ');

    const partState = { ...this.state.formData.warrantyClaimDetails[0] };
    partState.partNumber = pDetails[pDetails.length - 1];
    partState.wholePartNumber = this.props.RSClaimDetails.partNumber;
    partState.mfg = pDetails[0];
    partState.InvoiceOption = {
      value: this.props.RSClaimDetails.originalInvoiceNumber,
      label: this.props.RSClaimDetails.originalInvoiceNumber,
      invnum: this.props.RSClaimDetails.originalInvoiceNumber,
      isDisabled: false
    };
    // debugger;
    // partState.replacementInvNo="kkik999";
    if (this.props.RSClaimDetails.replacementInvoice) {
      partState.replacementInvNo = this.props.RSClaimDetails.replacementInvoice;
    }
    if (
      this.props.RSClaimDetails.originalPurchaseDate &&
      this.props.RSClaimDetails.originalPurchaseDate !== '0'
    ) {
      partState.orgpurchasedate = moment(
        this.getDateFormat(this.props.RSClaimDetails.originalPurchaseDate)
      ).format('MM/DD/YYYY');
    }
    // debugger;
    if (
      this.props.RSClaimDetails.replacementPurchaseDate &&
      this.props.RSClaimDetails.replacementPurchaseDate !== '0'
    ) {
      partState.partReplacementDate = moment(
        this.getDateFormat(this.props.RSClaimDetails.replacementPurchaseDate)
      ); // .format('MM/DD/YYYY');
    } else {
      partState.partReplacementDate = null;
    }
    // console.log(partState.partReplacementDate.isValid?true:false);
    const promise1 = new Promise((resolve, reject) => {
      WarrantyClaimService.getPartnumber(
        this.state.fieldsForSelectedBrand['datefilter'] === 'No' ? 'N' : 'Y',
        partState.partNumber
      )
        .then(response => {
          let selectedPartDetails: any[] = [];
          const partInvoiceLst: any[] = [];

          selectedPartDetails = response && response['data'];
          if (selectedPartDetails && selectedPartDetails.length > 0) {
            selectedPartDetails.map(a => {
              return partInvoiceLst.push({
                value: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
                label: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
                invnum: a.invoiceNumber,
                isDisabled: a.availableQuantity <= 0 ? true : false,
                quantity: a.availableQuantity,
                unitPrice: a.unitPrice
              });
            });

            // const partInvoiceShow: any[] = [];

            partState['partSelectedDetails'] = selectedPartDetails;
            partState.partInvoiceList = partInvoiceLst;
            const availableQuant = selectedPartDetails
              .filter(
                a =>
                  a.invoiceNumber ===
                  this.props.RSClaimDetails.originalInvoiceNumber
              )
              .map(quantity => quantity.availableQuantity);
            // console.log(availableQuant, 'availableQuant');
            partState['tempquantity'] = availableQuant[0]; // selectedPartDetails[0].availableQuantity;
            partState['testpartnum'] = 'filled';
          }
          resolve('partInvoiceList');
        })
        .catch(error => {
          resolve('partInvoiceList');
        });
    });

    Promise.all([promise1]).then((values: any) => {
      // Validation - if tempquantity is 0 then  do not allow to resubmit claim
      if(partState.tempquantity<=0){
        const quantityerror = [...this.state.errors.partsDetailsInvalidList];
        const error = true;
        error
         ? (quantityerror[0].quantityInvalidError = error)
         : (quantityerror[0].quantityInvalidError = '');
        this.setState({
         errors: {
           ...this.state.errors,
           partsDetailsInvalidList: [...quantityerror]
         }
        });
       }
      // End
      partState.quantity = Number(this.props.RSClaimDetails.quantity);
      partState.priceshow = this.getAmountFixedValue(
        this.props.RSClaimDetails.totalPrice *
          this.props.RSClaimDetails.quantity
      );
      partState.price =
        this.props.RSClaimDetails.quantity *
        this.props.RSClaimDetails.totalPrice;
      partState.unitprice = this.getAmountFixedValue(
        this.props.cResubmitDetails.cspUnitPrice
      );
      partState.unitpricenum = this.props.cResubmitDetails.cspUnitPrice;

      partState.invoiceNumber = this.props.RSClaimDetails.originalInvoiceNumber;
      const warrantyClaimDetails = [
        ...this.state.formData.warrantyClaimDetails
      ];
      warrantyClaimDetails[0] = partState;

      this.setState({
        formData: {
          ...this.state.formData,
          warrantyClaimDetails: [...warrantyClaimDetails]
        }
      });

      const stName: string =
        addressUSA.find(state => state.value === custDetails.state)?.name ||
        addressCA.find(state => state.value === custDetails.state)?.name;
      this.setState({
        selectedState: {
          name: stName,
          value: custDetails.state
        }
      });

      if (custDetails.state === 'NA') {
        this.setState({
          formData: {
            ...this.state.formData,
            otherstate: true,
            stateCode: ''
          }
        });
      } else {
        this.setState({
          formData: {
            ...this.state.formData,
            otherstate: false,

            stateCode: custDetails.state,
            customer: {
              ...this.state.formData.customer,
              state: stName
            }
          }
        });
      }
    });
    // const sltInv:ISelectOption={invnum:"",value:"",label:"",isDisabled:false};
    // this.handleOriginalinvoice(sltInv,0)
    // console.log(formData, 'did mount Method');
    // console.log("state form data Method");
    /* const brandMapingList: any[] = bmList;
    debugger;
    const selectBrandField: any[] = brandMapingList.filter(
      a =>
        (a['acf']['brand'] + '').toLowerCase() ===
        (this.props.RSClaimDetails.manufacturerCode + '').toLowerCase()
    );
    if (selectBrandField.length > 0) {
      this.setState({ fieldsForSelectedBrand: selectBrandField[0]['acf'] });
    } else {
      this.setState({ fieldsForSelectedBrand: {} });
    }
    const sltBrand:IBrand={
      value: this.props.RSClaimDetails.manufacturerCode,
      label: this.props.RSClaimDetails.manufacturerCode
    };
    this.setState({ selectedBrand: sltBrand }, () => {
      const data = {
        target: { ...this.state.selectedBrand, name: 'brand' }
      };
      this.handleDataSetting(data);
    });
    */
    /* if (this.selectRef) {
      this.selectRef.select.clearValue();
    }
    

    const mdlSelected:IModellist[] =[];
    mdlSelected.push({
      value: '12345',
      label: '12345'
    });
    this.setState({
      formData: {
        ...this.state.formData,
        ModelnumberSelected: mdlSelected
      }
    });
    this.setState({ModelnumberSelected: mdlSelected});

    this.setState({
      formData: {
        ...this.state.formData,
        partNumber: this.props.RSClaimDetails.partNumber,
      }
    }); */
    /* this.reset(
      selectBrandField[0]['acf']['servicePerformed'][0],
      selectBrandField[0]['acf']['serviceVerbage']
    ); 
    // formData.partNumber=this.props.RSClaimDetails.part;
   
    /* this.state = {
      formData: {
        accountNumber: this.props?.userData?.accountId
          ? this.props.userData.accountId
          : '',
        accountName: '',
        brand: this.props.RSClaimDetails.manufacturerCode,
        claimNumber: this.props.claimNumber, // number
        partNumber: this.props.RSClaimDetails.partNumber, //  strt mine
        customerNumber: '',
        servicePerformed: '',
        orginvoiceNumber: '',
        replacementInvNo: '',
        partprice: '',
        quantity: '',
        haveureturnpart: '',
        trackingnum: '',
        trackinglocation: '',
        refno: '',
        incidentNumber: '',
        purchasecost: '',
        picofpart: '',
        reset: false,
        modellist: false,
        reqreturn: '',
        producttype: '',
        supplierinvnum: '',
        supplierordernum: '',
        supplierponum: '',
        stateCode: '',
        picurl: '',
        errormsg: '',
        errormsgshow: false,
        ModelnumberList: [],
        ModelnumberSelected: [
          {
            value: 'Model Number',
            label: 'Model Number'
          }
        ],
        // end mine
        customer: {
          address: '',
          city: '',
          country: env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? 'Canada' : 'USA',
          firstName: '',
          number: '',
          lastName: '',
          phone: '',
          servicerEmail: '',
          servicerPhone: '',
          postalcode: '', // mine
          email: '', // mine
          state: '',
          zipCode: ''
        },
        customerComplaint: '',
        modelNumber: '',
        partInstalledDate: null,
        partcallReceivedDate: null,
        partFailedDate: null,
        partRepairDate: null,
        partPurchaseDate: null,
        partsupplierinvdate: null,
        serialNumber: '',
        warrantyClaimDetails: [{ ...this.partBase }],
        showUploadModal: false,
        uploadsuccess: true,
        otherstate: false,
        finalsubmit: false,
        picloading: false,
        picfailed: false
      },
      image: {
        open: false,
        files: []
      },
      component: {
        formValidated: false,
        fieldsFailed: []
      },
      brandMapingList: [],
      fieldsForSelectedBrand: {},
      brandSelect: [],
      selectedState:
        env.REACT_APP_BASE_ENVIRONMENT === 'CA'
          ? { name: ' ', value: '' }
          : { name: ' ', value: '' },
      selectedreturntag: yesno[0],
      selectedhavureturn: yesno[0],
      selectedproducttag: productList[0],
      selectedtrackinglocation:
        env.REACT_APP_BASE_ENVIRONMENT === 'CA'
          ? locationCA[0]
          : locationUSA[0],
      selectedBrand: null,
      errors: {
        supplierinvnumInvalidError: false,
        supplierordernumInvalidError: false,
        servicerEmailError: false,
        ReturnpartinvalidError: false,
        trackinglocationInvalidError: false,
        customerPhoneError: false,
        partInstalledDateError: false,
        partcallReceivedDateError: false,
        partFailDateError: false,
        partsDetailsInvalidList: [this.partError],
        incidentNumberInvalidError: false,
        accountNumberInvalidError: false,
        customerComplaintInvalidError: false,
        customerNumberError: false, //  start mine
        purchasecostInvalidError: false,
        picofpartInvalidError: false,
        claimNumberInvalidError: false,
        consumerprovinceError: false,
        partNumberInvalidError: false,
        modelNumberInvalidError: false,
        serialNumberInvalidError: false,
        servicePerformedInvalidError: false,
        customerFirstNameInvalidError: false,
        customerLastNameInvalidError: false,
        orginvoiceNumberInvalidError: false,
        RepinvNumberInvalidError: false,
        consumerEmailError: false,
        consumerpostalcodeInvalidError: false,
        partpriceInvalidError: false,
        partRepairDateError: false,
        trackingNumberInvalidError: false,
        partPurchaseDateError: false,
        quantityInvalidError: false,
        refnoInvalidError: false,
        supplierpoInvalidError: false,
        stateInvaliderror: false,
        reqforreturnInvalidError: false,
        servicerphoneError: false,
        customeraddressInvalidError: false,
        customercityInvalidError: false,
        customerstateInvalidError: false,
        haveureturnInvalidError: false,
        reqreturnInvalidError: false,
        producttypeInvalidError: false
      }
    };*/
  };
  public componentDidMount = () => {
    this.setState({
      isSubmitButtonDisabled: false
    });
    let bmList: any[] = null;
    // console.log(this.props.RSClaimDetails);
    const promise1 = new Promise((resolve, reject) => {
      WarrantyClaimService.usBrandList().then((response: any) => {
        // console.log(response.data);
        this.setState({ brandMapingList: response.data });
        bmList = response.data;
        resolve('usBrandList');
      });
    });

    const promise2 = new Promise((resolve, reject) => {
      WarrantyClaimService.getBrands().then((response: any) => {
        // console.log(response.data);
        this.formatBrands(response);
        resolve('formatBrands');
      });
    });
    Promise.all([promise1, promise2]).then((values: any) => {
      if (this.props.RSClaimDetails) {
        this.SetResubmitClaimDetails(bmList);
      }
    });

    document.addEventListener('click', this.modellistcheck);
    this.setState({
      isSubmitButtonDisabled: false
    });
  };
  public componentWillMount = () => {
    document.removeEventListener('click', this.modellistcheck);
  };

  private modellistcheck = (e: any) => {
    this.setState({
      formData: {
        ...this.state.formData,

        modellist: true
      }
    });
  };

  private formatBrands = (brands: any[]) => {
    const brandSelect = brands.map(brand => {
      return {
        value: brand.name,
        label: brand.name
      };
    });
    this.setState({ brandSelect });
  };

  /* 
    handleDataSetting: takes the name and value of input and sets it in the state
   */
  private handleDataSetting = (event: any) => {
    const { name, value } = event.target;
    // console.log(event.target);
    const customerState = { ...this.state.formData };
    customerState[name] = value;
    this.setState({ formData: customerState }, () => {
      this.validateForm();
    });
  };

  private setAccountName = (accountNumber: string) => {
    let name = '';
    this.props.userAccounts.map(account => {
      if (account.accountId === accountNumber) {
        name = account.name;
      }
      return;
    });
    return name;
  };

  private setInstalledDate = (installedDate: any) => {
    const customerState = { ...this.state.formData };

    customerState.partInstalledDate = installedDate;
    const error = moment(this.state.formData.partFailedDate).isBefore(
      installedDate
    );
    let errorcheck;
    if (this.state.fieldsForSelectedBrand['failedDate'][1] !== 'required') {
      errorcheck = moment(this.state.formData.partRepairDate).isBefore(
        installedDate
      );
    } else {
      errorcheck = moment(this.state.formData.partRepairDate).isBefore(
        this.state.formData.partFailedDate
      );
    }

    this.setState({
      formData: customerState,
      errors: {
        ...this.state.errors,
        partFailDateError: error,
        partRepairDateError: errorcheck
      }
    });
  };
  private setcallReceivedDate = (callReceivedDate: any) => {
    const customerState = { ...this.state.formData };

    customerState.partcallReceivedDate = callReceivedDate;

    this.setState({
      formData: customerState
    });
  };

  private setFailedDate = (failedDate: any) => {
    const customerState = { ...this.state.formData };
    customerState.partFailedDate = failedDate;
    const error = moment(this.state.formData.partRepairDate).isBefore(
      failedDate
    );
    const errorfail = moment(failedDate).isBefore(
      this.state.formData.partInstalledDate
    );
    this.setState({
      formData: customerState,
      errors: {
        ...this.state.errors,
        partRepairDateError: error,
        partFailDateError: errorfail
      }
    });
  };
  private setRepairDate = (repairDate: any) => {
    const customerState = { ...this.state.formData };
    customerState.partRepairDate = repairDate;
    const error =
      this.state.fieldsForSelectedBrand['failedDate'][1] === 'required'
        ? moment(repairDate).isBefore(this.state.formData.partFailedDate)
        : moment(repairDate).isBefore(this.state.formData.partInstalledDate);

    this.setState({
      formData: customerState,
      errors: {
        ...this.state.errors,
        partRepairDateError: error
      }
    });
  };
  private setPurchaseDate = (purchaseDate: any) => {
    const customerState = { ...this.state.formData };
    customerState.partPurchaseDate = purchaseDate;
    this.setState({
      formData: customerState
    });
  };
  private setRepDate = (replacementDate: any, index: any) => {
    const partState = { ...this.state.formData.warrantyClaimDetails[index] };
    partState['partReplacementDate'] = replacementDate;
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    warrantyClaimDetails[index] = partState;

    this.setState({
      formData: {
        ...this.state.formData,
        warrantyClaimDetails: [...warrantyClaimDetails]
      }
    });
  };

  /* 
    validateForm
   */
  private validateForm = () => {
    const newComponent = { ...this.state.component };
    newComponent.formValidated = true;
    newComponent.fieldsFailed = [];
    for (const property in this.state.formData) {
      if (this.state.formData.hasOwnProperty(property)) {
        if (property !== 'component') {
          if (
            property === 'claimNumber' &&
            this.state.formData.claimNumber === ''
          ) {
            this.setState({
              formData: {
                ...this.state.formData,
                claimNumber: this.props.claimNumber
              }
            });
          }
        }
      }
    }
    this.setState({ component: newComponent });
  };

  /* 
    buildFormData
   */
  private buildFormData = () => {
    const formData: any = { ...this.state.formData };
    formData.claimNumber = this.props.claimNumber;
    formData.partFailedDate = this.state.formData.partFailedDate.format(
      'YYYY-MM-DD'
    );
    formData.partInstalledDate = this.state.formData.partInstalledDate.format(
      'YYYY-MM-DD'
    );
    return formData;
  };
  private date = (n: number) => {
    return n > 9 ? '' + n : '0' + n;
  };

  private WarrantyFormData = () => {
    const formData: any = { ...this.state.formData };

    // console.log(formData, 'TOPFORMDTA');
    const partDetails: any[] = [];
    let partNo = null;

    // debugger;

    formData.warrantyClaimDetails.map((value: any, i: number) => {
      //  console.log(value , "W Part details");
      //
      let inv: any = 0;
      if (
        value.InvoiceOption &&
        value.InvoiceOption.invnum !== undefined &&
        value.InvoiceOption.invnum !== 'Select Invoice'
      ) {
        inv = value.InvoiceOption.invnum;
      } else {
        inv = value.invoiceNumber;
      }
      partDetails.push({
        descriptionOfDamage: '',
        invoiceNumber:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.invoiceNumber'] &&
          this.state.fieldsForSelectedBrand['part.invoiceNumber'][0] === 'true'
            ? inv
            : '0',
        manufacturerCode: value.mfg,
        partLineIndex: i + 1,
        partNumber:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.partNumber'] &&
          this.state.fieldsForSelectedBrand['part.partNumber'][0] === 'true'
            ? value.partNumber.toUpperCase()
            : '',
        wholePartNumber: value.wholePartNumber ? value.wholePartNumber : '',
        pictureOfPart:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.pictureOfPart'] &&
          this.state.fieldsForSelectedBrand['part.pictureOfPart'][0] === 'true'
            ? value.count >= value.quantity
              ? 'Y'
              : 'N'
            : '',
        purchaseDate:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.purchaseDate'] &&
          this.state.fieldsForSelectedBrand['part.purchaseDate'][1] ===
            'required'
            ? value.orgpurchasedate
              ? new Date(value.orgpurchasedate).getFullYear().toString() +
                this.date(new Date(value.orgpurchasedate).getMonth() + 1) +
                this.date(new Date(value.orgpurchasedate).getDate())
              : 0
            : 0,
        quantity:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.quantity'] &&
          this.state.fieldsForSelectedBrand['part.quantity'][0] === 'true'
            ? Number(value.quantity)
            : 0,
        replacementDate:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.replacementDate'] &&
          this.state.fieldsForSelectedBrand['part.replacementDate'][1] ===
            'required'
            ? value.partReplacementDate
              ? value.partReplacementDate._d.getFullYear().toString() +
                this.date(value.partReplacementDate._d.getMonth() + 1) +
                this.date(value.partReplacementDate._d.getDate())
              : 0
            : 0,
        replacementInvoice:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.replacementInvoice'] &&
          this.state.fieldsForSelectedBrand['part.replacementInvoice'][0] ===
            'true'
            ? value.replacementInvNo
            : '',
        totalPrice:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.price'] &&
          this.state.fieldsForSelectedBrand['part.price'][0] === 'true'
            ? value.price
            : 0,
        unitPrice:
          this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['part.price'] &&
          this.state.fieldsForSelectedBrand['part.price'][0] === 'true'
            ? value.unitpricenum
            : 0
      });
    });
    const warrantyData: any = {
      accountNumber: formData.accountNumber,
      brand: formData.brand,
      claimResubmit: '',
      previousClaimNumber: '',
      claimNumber: formData.claimNumber,
      customer: {
        address: formData.customer.address ? formData.customer.address : '',
        city: formData.customer.city ? formData.customer.city : '',
        email: formData.customer.email ? formData.customer.email : '',
        firstName: formData.customer.firstName
          ? formData.customer.firstName
          : '',
        lastName: formData.customer.lastName ? formData.customer.lastName : '',
        phone: formData.customer.phone ? formData.customer.phone : '',
        state: formData.stateCode ? formData.stateCode : '',
        zipCode: formData.customer.postalcode
          ? formData.customer.postalcode
          : ''
      },
      customerComplaint:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['customerComplaint'] &&
        this.state.fieldsForSelectedBrand['customerComplaint'][0] === 'true'
          ? formData.customerComplaint
          : '',
      failedDate:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['failedDate'] &&
        this.state.fieldsForSelectedBrand['failedDate'][1] === 'required'
          ? formData.partFailedDate
            ? formData.partFailedDate._d.getFullYear().toString() +
              this.date(formData.partFailedDate._d.getMonth() + 1) +
              this.date(formData.partFailedDate._d.getDate())
            : 0
          : 0,

      installedDate:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['installedDate'] &&
        this.state.fieldsForSelectedBrand['installedDate'][1] === 'required'
          ? formData.partInstalledDate
            ? formData.partInstalledDate._d.getFullYear().toString() +
              this.date(formData.partInstalledDate._d.getMonth() + 1) +
              this.date(formData.partInstalledDate._d.getDate())
            : 0
          : 0,
      isReturned: formData.haveureturnpart ? formData.haveureturnpart : '',
      locationForReturn: formData.trackinglocation
        ? formData.trackinglocation
        : '',
      modelBrand: formData.brand,
      modelNumber:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['modelNumber'] &&
        this.state.fieldsForSelectedBrand['modelNumber'][0] === 'true'
          ? formData.modelNumber
          : '',
      part: partDetails,
      purchaseCost: formData.purchasecost ? formData.purchasecost : 0,
      referenceNumber:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['referenceNumber'] &&
        this.state.fieldsForSelectedBrand['referenceNumber'][0] === 'true'
          ? formData.refno
          : '',
      repairDate:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['repairDate'] &&
        this.state.fieldsForSelectedBrand['repairDate'][1] === 'required'
          ? formData.partRepairDate
            ? formData.partRepairDate._d.getFullYear().toString() +
              this.date(formData.partRepairDate._d.getMonth() + 1) +
              this.date(formData.partRepairDate._d.getDate())
            : 0
          : 0,
      requestReturnTag: formData.reqreturn ? formData.reqreturn : '',
      serialNumber:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['serialNumber'] &&
        this.state.fieldsForSelectedBrand['serialNumber'][0] === 'true'
          ? formData.serialNumber
          : '',
      servicePerformed:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['servicePerformed'] &&
        this.state.fieldsForSelectedBrand['servicePerformed'][0] === 'true'
          ? formData.servicePerformed
          : '',
      source: 'NS3',
      servicerEmail:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['emailServicer'] &&
        this.state.fieldsForSelectedBrand['emailServicer'][0] === 'true'
          ? formData.customer.servicerEmail
          : '',
      servicerPhoneNumber:
        this.state.fieldsForSelectedBrand &&
        this.state.fieldsForSelectedBrand['servicerPhoneNumber'] &&
        this.state.fieldsForSelectedBrand['servicerPhoneNumber'][0] === 'true'
          ? formData.customer.servicerPhone
          : '',
      supplierInvoiceNumber: formData.supplierinvnum
        ? formData.supplierinvnum
        : '',
      supplierInvoiceDate: formData.partsupplierinvdate
        ? formData.partsupplierinvdate._d.getFullYear().toString() +
          this.date(formData.partsupplierinvdate._d.getMonth() + 1) +
          this.date(formData.partsupplierinvdate._d.getDate())
        : 0,
      supplierOrderNumber: formData.supplierordernum
        ? formData.supplierordernum
        : '',
      supplierPoNumber: formData.supplierponum ? formData.supplierponum : '',
      trackingNumber: formData.trackingnum ? formData.trackingnum : '',
      incidentNumbers:
        (this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['incidentNumbers'] &&
          this.state.fieldsForSelectedBrand['incidentNumbers'][0] === 'true') ||
        (this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['incidentNumbers'] &&
          this.state.fieldsForSelectedBrand['incidentNumbers'][1] ===
            'required')
          ? formData.incidentNumber
          : '',
      productTypes:
        (this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['productTypes'] &&
          this.state.fieldsForSelectedBrand['productTypes'][0] === 'true') ||
        (this.state.fieldsForSelectedBrand &&
          this.state.fieldsForSelectedBrand['productTypes'] &&
          this.state.fieldsForSelectedBrand['productTypes'][1] === 'required')
          ? formData.producttype
          : '',
          claimType: 'partFailedAfterInstall'
    };
    // console.log(warrantyData,'warrantydata')
    if (this.props.RSClaimDetails) {
      warrantyData.claimResubmit = 'Y';
      warrantyData.previousClaimNumber = this.props.RSClaimDetails.claimNumber;

      const invoice = this.props.RSClaimDetails.originalInvoiceNumber;
      partNo = partDetails[0].partNumber;

      // if (partNo!=='') {
      //   WarrantyClaimService.getPartnumber(
      //     this.state.fieldsForSelectedBrand['datefilter'] === 'No' ? 'N' : 'Y',
      //     partNo
      //   )
      //     .then(response => {
      //       let selectedPartDetails: any[] = [];
      //       const partInvoiceLst: any[] = [];

      //       selectedPartDetails = response && response['data'];

      //       selectedPartDetails.map(a => {
      //         return partInvoiceLst.push({
      //           value: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
      //           label: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
      //           invnum: a.invoiceNumber,
      //           isDisabled: a.availableQuantity <= 0 ? true : false
      //         });
      //       });

      //     const selectedInvoice = selectedPartDetails.filter(
      //       a => a.invoiceNumber === invoice.toString()
      //     );
      //     if (selectedInvoice && selectedInvoice.length > 0) {

      //       warrantyData.part[0].manufacturerCode = selectedInvoice[0].manufacturerCode;
      //       warrantyData.part[0].wholePartNumber = selectedInvoice[0].partNumber;

      //       }

      //     })
      //     // .catch(error1 => {

      //     // });
      // }
    }
    return warrantyData;
  };

  private warrantyCallService = (dataForm: any) => {
    let spinnerstatus = 'nothing';
    const picspinner = [...this.state.formData.warrantyClaimDetails];
    let c;
    let d;
    if (this.state.formData.brand === 'LG') {
      for (c = 0; c < picspinner.length; c++) {
        if (picspinner[c].price > 80) {
          for (d = 0; d < picspinner[c].pictureofparts.length; d++) {
            if (picspinner[c].pictureofparts[d].spinner === 'start') {
              spinnerstatus = 'spinnerspinning';
              break;
            } else if (picspinner[c].pictureofparts[d].spinner === 'failure') {
              spinnerstatus = 'spinnerfailed';
            }
          }
        }
      }
    }
    if (!this.isFormvalid() && spinnerstatus === 'nothing') {
      this.setState({
        isSubmitButtonDisabled: true
      });
      WarrantyClaimService.newWarrantyClaim(dataForm)
        .then(response => {
          this.props.onSuccess();
        })
        .catch(error => {
          this.submiterrormsg(error.response.data.message);
          this.setState({
            formData: {
              ...this.state.formData,
              finalsubmit: true
            }
          });
          this.setState({
            isSubmitButtonDisabled: false
          });
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    } else {
      const parterrorinfo = [...this.state.errors.partsDetailsInvalidList];
      const parterrordetails = [
        'partNumberInvalidError',
        'quantityInvalidError',
        'partpriceInvalidError',
        'RepinvNumberInvalidError',
        'orginvoiceNumberInvalidError'
      ];
      let partinvalid = false;
      parterrorinfo.forEach(item => {
        for (const key in item) {
          if (parterrordetails.includes(key) && item[key] === true) {
            partinvalid = true;
          }
        }
      });
      !this.isFormInvalid() || (partinvalid && this.isFormvalid())
        ? this.submiterrormsg(`${i18n.t('partClaim.errorwithmsg')}`)
        : !this.isFormInvalid() || partinvalid
        ? this.submiterrormsg(`${i18n.t('partClaim.correcterror')}`)
        : this.submiterrormsg(`${i18n.t('partClaim.highlighterror')}`);
      if (
        spinnerstatus === 'spinnerspinning' ||
        spinnerstatus === 'spinnerfailed'
      ) {
        this.setState({
          formData: {
            ...this.state.formData,
            picloading: spinnerstatus === 'spinnerspinning' ? true : false,
            picfailed: spinnerstatus === 'spinnerfailed' ? true : false
          }
        });
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };
  private checkfinalspinnerstatus = (): any => {
    let spinnerstatus = 'nothing';
    const picspinner = [...this.state.formData.warrantyClaimDetails];
    let c;
    let d;
    if (this.state.formData.brand === 'LG') {
      for (c = 0; c < picspinner.length; c++) {
        if (picspinner[c].price > 80) {
          for (d = 0; d < picspinner[c].pictureofparts.length; d++) {
            if (picspinner[c].pictureofparts[d].spinner === 'start') {
              spinnerstatus = 'spinnerspinning';
              break;
            } else if (picspinner[c].pictureofparts[d].spinner === 'failure') {
              spinnerstatus = 'spinnerfailed';
            }
          }
        }
      }
    }
    return spinnerstatus;
  };
  private submiterrormsg = (data: any) => {
    this.setState({
      formData: {
        ...this.state.formData,
        errormsg: data,
        errormsgshow: true
      }
    });
  };
  private spinnererrorremove = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        picloading: false,
        picfailed: false
      }
    });
  };
  private errormsgremove = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        errormsg: '',
        errormsgshow: false
      }
    });
  };
  private finalsubmitremove = () => {
    this.setState({
      formData: {
        ...this.state.formData,
        finalsubmit: false
      }
    });
  };

  //  currency Formatter //

  private currencyFormatter = (amount: any) => {
    if (amount) {
      const amountVal = Number(amount);
      const format = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      return format.format(amountVal);
    }
    return '$00.00';
  };

  /* add another part */
  private addPart = () => {
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];

    const partsDetailsInvalidList = [
      ...this.state.errors.partsDetailsInvalidList
    ];
    const date: any = null;
    const NewpartData = {
      partNumber: '',
      quantity: 0,
      price: 0,
      replacementInvNo: '',
      invoiceNumber: 0,
      orgpurchasedate: '',
      tempquantity: 1,
      priceshow: '',
      quantityshow: '',
      totalprice: '',
      unitprice: '',
      unitpricenum: 0,
      partReplacementDate: date,
      spinner: false,
      count: 0,
      mfg: '',
      funentrycount: 0,
      wholePartNumber: '',
      loadingerror: false,
      open: false,
      maxsize: false,
      imagetype: false,
      picofpart: [''],
      fileArray: [''],
      tempfilearray: [''],
      uploadedfile: [''],
      imagepreview: [''],
      fileobject: [''],
      indexImage: 0,
      showUploadModal: false,
      deletepic: false,
      testpartnum: '',

      pictureofparts: [
        {
          filename: '',
          spinner: '',
          file: [''],
          imagecount: 0,
          imgfail: '',
          imgthumbnail: ''
        }
      ],
      pictureofpartstemp: [
        {
          filename: '',
          spinner: '',
          file: [''],
          imagecount: 0,
          imgfail: '',
          imgthumbnail: ''
        }
      ],
      InvoiceOption: {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice',
        isDisabled: false,
        wholePartNumber: ''
      },
      partSelectedDetails: [
        {
          invoiceNumber: 'Select Invoice',
          partNumber: '',

          availableQuantity: 0,
          unitPrice: 0,
          purchaseDate: '',
          manufacturerCode: '',
          invoiceDate: '',
          wholePartNumber: ''
        }
      ],
      Invoiceoption: {},
      partInvoiceList: [
        {
          value: 'Select Invoice',
          label: 'Select Invoice',
          invnum: 'Select Invoice',
          isDisabled: false,
          wholePartNumber: ''
        }
      ],
      partInvoiceListtemp: [
        {
          value: 'Select Invoice',
          label: 'Select Invoice',
          invnum: 'Select Invoice'
        }
      ]
    };
    partsDetailsInvalidList.push({ ...this.partError });
    warrantyClaimDetails.push(NewpartData);

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        warrantyClaimDetails: [...warrantyClaimDetails]
      },
      errors: {
        ...prevState.errors,
        partsDetailsInvalidList: [...partsDetailsInvalidList]
      }
    }));
  };

  /* remove part */
  private removePart = (index: number) => {
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    const partsDetailsInvalidList = [
      ...this.state.errors.partsDetailsInvalidList
    ];

    warrantyClaimDetails.splice(index, 1);
    partsDetailsInvalidList.splice(index, 1);
    this.setState(prevState => ({
      formData: { ...prevState.formData, warrantyClaimDetails },
      errors: {
        ...prevState.errors,
        partsDetailsInvalidList: [...partsDetailsInvalidList]
      }
    }));
  };

  private onBrandSelected = (brand: IBrand) => {
    const brandMapingList: any[] = this.state.brandMapingList;

    const selectBrandField: any[] = brandMapingList.filter(
      a =>
        (a['acf']['brand'] + '').toLowerCase() ===
        (brand.value + '').toLowerCase()
    );
    if (selectBrandField.length > 0) {
      this.setState({ fieldsForSelectedBrand: selectBrandField[0]['acf'] });
    } else {
      this.setState({ fieldsForSelectedBrand: {} });
    }

    this.setState({ selectedBrand: brand }, () => {
      const data = {
        target: { ...this.state.selectedBrand, name: 'brand' }
      };
      this.handleDataSetting(data);
    });

    if (this.selectRef) {
      this.selectRef.select.clearValue();
    }
    try {
      this.reset(
        selectBrandField[0]['acf']['servicePerformed'][0],
        selectBrandField[0]['acf']['serviceVerbage']
      );
    } catch (error) {
      const ce: any = error;
    }
  };

  private reset = (req: string, verbiage: string) => {
    this.setState({
      formData: {
        ...this.state.formData,
        customer: {
          address: '',
          city: '',
          country: 'US',
          firstName: '',
          number: '',
          lastName: '',
          phone: '',
          servicerEmail: '',
          servicerPhone: '',
          postalcode: '', // mine
          email: '', // mine
          state: '',
          zipCode: ''
        },
        warrantyClaimDetails: [
          {
            partNumber: '',
            quantity: 0,
            price: 0,
            totalprice: '',
            unitpricenum: 0,
            replacementInvNo: '',
            invoiceNumber: 0,
            orgpurchasedate: '',
            tempquantity: 1,
            quantityshow: '',
            priceshow: '',
            unitprice: '',
            funentrycount: 0,
            partReplacementDate: null,
            spinner: false,
            loadingerror: false,
            count: 0,
            picofpart: [''],
            fileArray: [''],
            tempfilearray: [''],
            uploadedfile: [''],
            imagepreview: [''],
            indexImage: 0,
            showUploadModal: false,
            deletepic: false,
            testpartnum: '',
            mfg: '',
            wholePartNumber: '',
            open: false,
            maxsize: false,
            imagetype: false,
            pictureofparts: [
              {
                filename: '',
                spinner: '',
                file: [''],
                imagecount: 0,
                imgfail: '',
                imgthumbnail: ''
              }
            ],
            pictureofpartstemp: [
              {
                filename: '',
                spinner: '',
                file: [''],
                imagecount: 0,
                imgfail: '',
                imgthumbnail: ''
              }
            ],
            InvoiceOption: {
              value: 'Select Invoice',
              label: 'Select Invoice',
              invnum: 'Select Invoice',
              isDisabled: false
            },
            partSelectedDetails: [
              {
                invoiceNumber: 'Select Invoice',
                partNumber: '',
                availableQuantity: 0,
                unitPrice: 0,
                purchaseDate: '',
                manufacturerCode: '',
                invoiceDate: '',
                wholePartNumber: ''
              }
            ],
            fileobject: [''],
            partInvoiceList: [
              {
                value: 'Select Invoice',
                label: 'Select Invoice',
                invnum: 'Select Invoice',
                isDisabled: false
              }
            ],
            partInvoiceListtemp: [
              {
                value: 'Select Invoice',
                label: 'Select Invoice',
                invnum: 'Select Invoice'
              }
            ]
          }
        ],
        customerComplaint: '',
        modelNumber: '',
        ModelnumberList: [],
        partInstalledDate: null,
        partcallReceivedDate: null,
        partFailedDate: null,
        partRepairDate: null,
        partPurchaseDate: null,
        partsupplierinvdate: null,
        serialNumber: '',
        servicePerformed:
          i18n.language === 'fr-CA' && req === 'true'
            ? 'Pièce remplacée testée OK'
            : req === 'true' && verbiage
            ? verbiage
            : '',
        orginvoiceNumber: '',
        replacementInvNo: '',
        partprice: '',
        quantity: '',
        haveureturnpart: '',
        trackingnum: '',
        trackinglocation: '',
        refno: '',
        purchasecost: '',
        picofpart: '',
        picurl: '',
        incidentNumber: '',
        reqreturn: '',
        supplierinvnum: '',
        supplierordernum: '',
        supplierponum: '',
        stateCode: '',
        otherstate: false,
        errormsg: '',
        errormsgshow: false,
        finalsubmit: false,
        producttype: '',
        reset: true,
        modellist: false,
        picloading: false,
        picfailed: false
      },
      errors: {
        supplierinvnumInvalidError: false,
        supplierordernumInvalidError: false,
        servicerEmailError: false,
        ReturnpartinvalidError: false,
        trackinglocationInvalidError: false,
        customerPhoneError: false,
        partInstalledDateError: false,
        partcallReceivedDateError: false,
        partFailDateError: false,
        partsDetailsInvalidList: [
          {
            partNumberInvalidError: false,
            quantityInvalidError: false,
            partpriceInvalidError: false,
            RepinvNumberInvalidError: false,
            orginvoiceNumberInvalidError: false
          }
        ],
        incidentNumberInvalidError: false,
        accountNumberInvalidError: false,
        customerComplaintInvalidError: false,
        customerNumberError: false, //  start mine
        purchasecostInvalidError: false,
        picofpartInvalidError: false,
        claimNumberInvalidError: false,
        consumerprovinceError: false,
        partNumberInvalidError: false,
        modelNumberInvalidError: false,
        serialNumberInvalidError: false,
        servicePerformedInvalidError: false,
        customerFirstNameInvalidError: false,
        customerLastNameInvalidError: false,
        orginvoiceNumberInvalidError: false,
        RepinvNumberInvalidError: false,
        consumerEmailError: false,
        consumerpostalcodeInvalidError: false,
        partpriceInvalidError: false,
        partRepairDateError: false,
        trackingNumberInvalidError: false,
        partPurchaseDateError: false,
        quantityInvalidError: false,
        refnoInvalidError: false,
        supplierpoInvalidError: false,
        stateInvaliderror: false,
        reqforreturnInvalidError: false,
        servicerphoneError: false,
        customeraddressInvalidError: false,
        customercityInvalidError: false,
        customerstateInvalidError: false,
        haveureturnInvalidError: false,
        reqreturnInvalidError: false,
        producttypeInvalidError: false
      },
      selectedState: { name: ' ', value: '' },
      selectedhavureturn: { name: 'Select', value: '', label: '' },
      selectedreturntag: { name: 'Select', value: '', label: '' },
      selectedproducttag: {
        name: 'Select',
        value: '',
        label: ''
      },
      selectedtrackinglocation: { name: 'Select Location', value: '' },
      claimType:'partFailedAfterInstall'
    });
  };
  private isLgbrand = () => {
    const warrantyData = this.WarrantyFormData();
    const checksubmit = [...this.state.formData.warrantyClaimDetails];
    const a = [];
    for (const key in this.state.fieldsForSelectedBrand) {
      if (
        Array.isArray(this.state.fieldsForSelectedBrand[key]) &&
        this.state.fieldsForSelectedBrand[key].includes('required')
      ) {
        a.push(key);
      }
    }
    const result = a.some(data => {
      const splitarr = data.split('.');
      let finaldata;

      switch (splitarr.length) {
        case 1:
          finaldata = warrantyData[splitarr[0]];

          break;

        case 2:
          if (splitarr[0] === 'part') {
            for (let i = 0; i < warrantyData.part.length; i++) {
              finaldata = warrantyData[splitarr[0]][i][splitarr[1]];
            }
          } else {
            finaldata = warrantyData[splitarr[0]][splitarr[1]];
          }
          break;
      }
      return finaldata === '' || finaldata === 0;
    });

    return result || this.checksubmit();
  };
  public checksubmit = () => {
    const warrantyData = this.WarrantyFormData();
    const length = warrantyData.part.length;
    const uploadbtn = { ...this.state.formData.warrantyClaimDetails };
    let checksubmit;
    for (let i = 0; i < length; i++) {
      const totalprice = uploadbtn[i].unitpricenum;
      if (totalprice > 80) {
        if (uploadbtn[i].count >= uploadbtn[i].quantity) {
          checksubmit = false;
        } else {
          checksubmit = true;
          break;
        }
      } else {
        checksubmit = false;
      }
    }
    return checksubmit;
  };
  public checkspinner = (index: any, quantity: any): boolean => {
    const uploadpic = [
      ...this.state.formData.warrantyClaimDetails[index].pictureofparts
    ];
    const uploadbtn = { ...this.state.formData.warrantyClaimDetails[index] };
    let a;
    let status;
    const qnty = uploadbtn['showUploadModal'] === true ? uploadpic.length : 0;
    const filelimitcalc = qnty >= 3 * quantity ? true : false;
    if (uploadbtn['showUploadModal'] === true) {
      if (uploadpic.length > 0) {
        for (a = 0; a < 1; a++) {
          if (uploadpic[a].spinner === 'failure') {
            status = false;
            break;
          } else {
            status = true;
          }
        }
      }
    }
    return status && filelimitcalc;
  };

  private checkstatus = (index: any) => {
    const uploadpic = [
      ...this.state.formData.warrantyClaimDetails[index].pictureofparts
    ];
    const uploadbtn = { ...this.state.formData.warrantyClaimDetails[index] };
    let i;
    let status = false;
    for (i = 0; i < uploadbtn['pictureofparts'].length; i++) {
      if (uploadbtn['pictureofparts'][i].spinner === 'start') {
        status = true;
        break;
      }
    }
    return status;
  };

  public isFormInvalid = (): boolean => {
    const warrantyData = this.WarrantyFormData();
    const arr = Object.keys(this.state.errors).map(
      key => this.state.errors[key]
    );
    arr[9] = false;
    return arr.every(value => value === false);
  };

  private isFormvalid = () => {
    let lgbrand = false;

    if (this.state.formData.brand === 'LG') {
      if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
        lgbrand = this.isLgbrand();
      }
    }
    const warrantyData = this.WarrantyFormData();
    const a = [];
    const parterrorinfo = [...this.state.errors.partsDetailsInvalidList];
    const parterrordetails = [
      'partNumberInvalidError',
      'quantityInvalidError',
      'partpriceInvalidError',
      'RepinvNumberInvalidError',
      'orginvoiceNumberInvalidError'
    ];
    let partinvalid = false;
    parterrorinfo.forEach(item => {
      for (const key in item) {
        if (parterrordetails.includes(key) && item[key] === true) {
          partinvalid = true;
        }
      }
    });

    for (const key in this.state.fieldsForSelectedBrand) {
      if (
        Array.isArray(this.state.fieldsForSelectedBrand[key]) &&
        this.state.fieldsForSelectedBrand[key].includes('required')
      ) {
        a.push(key);
      }
    }

    const result = a.some(data => {
      const splitarr = data.split('.');
      let finaldata;
      switch (splitarr.length) {
        case 1:
          if (splitarr[0] === 'servicerEmail') {
            splitarr[0] = 'servicerEmail';
            finaldata = warrantyData[splitarr[0]];
          }
          finaldata =
            typeof warrantyData[splitarr[0]] === 'string'
              ? warrantyData[splitarr[0]].trim()
              : warrantyData[splitarr[0]];

          break;

        case 2:
          if (splitarr[0] === 'part') {
            if (
              splitarr[1] === 'invoiceNumber' ||
              splitarr[1] === 'partNumber' ||
              splitarr[1] === 'purchaseDate' ||
              splitarr[1] === 'quantity' ||
              splitarr[1] === 'replacementDate' ||
              splitarr[1] === 'replacementInvoice'
            ) {
              for (let i = 0; i < warrantyData.part.length; i++) {
                finaldata = warrantyData[splitarr[0]][i][splitarr[1]];
              }
            } else {
              if (splitarr[1] === 'returnTrackingLocation') {
                splitarr[1] = 'locationForReturn';
                finaldata = warrantyData[splitarr[1]];
              }
              finaldata = warrantyData[splitarr[1]];
              break;
            }
          } else {
            finaldata =
              typeof warrantyData[splitarr[0]][splitarr[1]] === 'string'
                ? warrantyData[splitarr[0]][splitarr[1]].trim()
                : warrantyData[splitarr[0]][splitarr[1]];
            break;
          }
          break;
      }
      return finaldata === '' || finaldata === 0;
    });
    const formerror = false;
    return (
      !this.isFormInvalid() || result || partinvalid || lgbrand || formerror
    );
  };

  // MY PART //

  private handleotherstate = (event: any) => {
    const { name, value } = event.target;
    const error = value.length > 2 || MustbNumericRegEx.test(value);
    this.setState({
      formData: {
        ...this.state.formData,
        stateCode: event.target.value
      },
      errors: {
        ...this.state.errors,
        stateInvaliderror: error
      }
    });
  };

  private handlePartNumber = (event: any, index: number) => {
    const { name, value } = event.target;
    const partState = { ...this.state.formData.warrantyClaimDetails[index] };
    const wholeerror = [...this.state.errors.partsDetailsInvalidList];
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    const nameSplit: any = name.split('.');
    partState[nameSplit[1]] = value;
    partState['partSelectedDetails'] = [];
    partState['invoiceNumber'] = 0;
    partState['price'] = 0;
    partState['priceshow'] = '$0.00';
    partState['unitpricenum'] = 0;
    partState['quantity'] = 0;
    partState['InvoiceOption'] = {
      value: 'Select Invoice',
      label: 'Select Invoice',
      invnum: 'Select Invoice',
      isDisabled: false
    };
    partState['partInvoiceList'] = [
      {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice',
        isDisabled: false
      }
    ];
    partState['orgpurchasedate'] = '';
    partState['unitprice'] = '$0.00';
    partState['testpartnum'] = '';
    partState['tempquantity'] = 1;
    wholeerror[index].orginvoiceNumberInvalidError = false;
    wholeerror[index].quantityInvalidError = false;
    this.setState({
      formData: {
        ...this.state.formData,
        warrantyClaimDetails
      }
    });
    if (value.trim() !== '') {
      WarrantyClaimService.getPartnumber(
        this.state.fieldsForSelectedBrand['datefilter'] === 'No' ? 'N' : 'Y',
        value
      )
        .then(response => {
          let selectedPartDetails: any[] = [];
          const partInvoiceLst: any[] = [];
          const partInvoiceShow: any[] = [];
          selectedPartDetails = response && response['data'];
          partState['partSelectedDetails'] = selectedPartDetails;
          selectedPartDetails.map(a => {
            return partInvoiceLst.push({
              value: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
              label: a.invoiceNumber + '  ' + '--' + ' ' + a.invoiceDate,
              invnum: a.invoiceNumber,
              isDisabled: a.availableQuantity <= 0 ? true : false,
              quantity: a.availableQuantity,
              unitPrice: a.unitPrice
            });
          });
          partState['partInvoiceList'] = partInvoiceLst;
          partState['partInvoiceShow'] = partInvoiceShow;
          if (partInvoiceLst.length === 0) {
            partState['partSelectedDetails'] = [];
            partState['invoiceNumber'] = 0;
            partState['price'] = 0;
            partState['priceshow'] = '$0.00';
            partState['unitpricenum'] = 0;
            partState['quantity'] = 0;
            partState['InvoiceOption'] = {
              value: 'Select Invoice',
              label: 'Select Invoice',
              invnum: 'Select Invoice',
              isDisabled: false
            };
            partState['orgpurchasedate'] = '';
            partState['unitprice'] = '$0.00';
            partState['testpartnum'] = '';
            partState['tempquantity'] = 1;
          }

          partState['testpartnum'] = 'filled';
          this.setState({
            formData: {
              ...this.state.formData,
              warrantyClaimDetails
            }
          });
        })
        .catch(error1 => {
          partState['partInvoiceList'] = [
            {
              value: 'Select Invoice',
              label: 'Select Invoice',
              invnum: 'Select Invoice',
              isDisabled: false
            }
          ];
          partState['partSelectedDetails'] = [];
          partState['invoiceNumber'] = 0;
          partState['price'] = 0;
          partState['priceshow'] = '$0.00';
          partState['unitpricenum'] = 0;
          partState['quantity'] = 0;
          partState['InvoiceOption'] = {
            value: 'Select Invoice',
            label: 'Select Invoice',
            invnum: 'Select Invoice',
            isDisabled: false
          };
          partState['orgpurchasedate'] = '';
          partState['unitprice'] = '$0.00';
          partState['testpartnum'] = '';
          partState['tempquantity'] = 1;

          // this.setState({
          //   formData: {
          //     ...this.state.formData,
          //     warrantyClaimDetails
          //   }
          // });
        });
    }

    const parterrors = [...this.state.errors.partsDetailsInvalidList];
    warrantyClaimDetails[index] = partState;
    this.setState({
      formData: { ...this.state.formData, warrantyClaimDetails },
      errors: {
        ...this.state.errors,
        partsDetailsInvalidList: [...parterrors]
      }
    });
  };
  private partnumerror = (index: number) => {
    const partState = { ...this.state.formData.warrantyClaimDetails[index] };

    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    partState['partInvoiceList'] = [
      {
        value: 'Select Invoice',
        label: 'Select Invoice',
        invnum: 'Select Invoice',
        isDisabled: false
      }
    ];
    partState['partSelectedDetails'] = [];
    partState['invoiceNumber'] = 0;
    partState['price'] = 0;
    partState['priceshow'] = '$0.00';
    partState['unitpricenum'] = 0;
    partState['quantity'] = 0;
    partState['InvoiceOption'] = {
      value: 'Select Invoice',
      label: 'Select Invoice',
      invnum: 'Select Invoice',
      isDisabled: false
    };
    partState['orgpurchasedate'] = '';
    partState['unitprice'] = '$0.00';
    partState['testpartnum'] = '';
    partState['tempquantity'] = 1;
    partState['mfg'] = '';
    partState['wholePartNumber'] = '';

    this.setState({
      formData: {
        ...this.state.formData,
        warrantyClaimDetails
      }
    });
  };

  private uploadMultipleFiles = (uploadedFiles: any, index: number) => {
    const uploadbtn = { ...this.state.formData.warrantyClaimDetails[index] };
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    const picState = [
      ...this.state.formData.warrantyClaimDetails[index].picofpart
    ];
    const picfile = [
      ...this.state.formData.warrantyClaimDetails[index].fileArray
    ];
    const tempfile = [
      ...this.state.formData.warrantyClaimDetails[index].tempfilearray
    ];
    const imgprw = [
      ...this.state.formData.warrantyClaimDetails[index].imagepreview
    ];
    const uploadpic = [
      ...this.state.formData.warrantyClaimDetails[index].pictureofparts
    ];

    if (uploadedFiles.length !== 0) {
      if (picState[0] === '') {
        picState.pop();
        picfile.pop();
        tempfile.pop();
        imgprw.pop();
        uploadpic.pop();
      }
      let i;
      for (i = 0; i < uploadedFiles.length; i++) {
        this.uploadQueue.push({
          file: uploadedFiles[i].file,
          partIndex: index,
          productIndex: picState.length
        });
        picState.push(uploadedFiles[i].file.name);
        picfile.push(uploadedFiles[i].file);
        tempfile.push(uploadedFiles[i].file);

        uploadpic.push({
          filename: uploadedFiles[i].file.name,
          file: uploadedFiles[i].file,
          spinner: '',
          imagecount: i,

          imgthumbnail: uploadedFiles[i].data
        });

        imgprw.push(uploadedFiles[i].data);
      }

      if (picState.length >= 1) {
        warrantyClaimDetails[index].showUploadModal = true;
        uploadbtn['showUploadModal'] = true;
        warrantyClaimDetails[index].showUploadModal =
          uploadbtn['showUploadModal'];
      } else {
        warrantyClaimDetails[index].showUploadModal = false;
        uploadbtn['showUploadModal'] = false;
        warrantyClaimDetails[index].showUploadModal =
          uploadbtn['showUploadModal'];
      }
      warrantyClaimDetails[index].picofpart = picState;
      warrantyClaimDetails[index].fileArray = picfile;
      warrantyClaimDetails[index].tempfilearray = tempfile;
      warrantyClaimDetails[index].imagepreview = imgprw;
      warrantyClaimDetails[index].pictureofparts = uploadpic;

      this.setState(
        {
          formData: {
            ...this.state.formData,

            warrantyClaimDetails
          }
        },
        () => {
          this.picloop(uploadedFiles, index);
        }
      );
    }
  };

  private picloop = async (file: any, index: any) => {
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    const uploadDetails = {
      ...this.state.formData.warrantyClaimDetails[index]
    };
    let l;
    let uploadinprogress = false;

    for (l = 0; l < uploadDetails['pictureofparts'].length; l++) {
      if (uploadDetails['pictureofparts'][l].spinner === 'start') {
        uploadinprogress = true;
      }
      if (uploadDetails['pictureofparts'][l].spinner === '') {
        uploadDetails['pictureofparts'][l].spinner = 'start';
      }
    }

    warrantyClaimDetails[index].pictureofparts =
      uploadDetails['pictureofparts'];
    this.setState({
      formData: {
        ...this.state.formData,
        warrantyClaimDetails
      }
    });

    if (this.uploadQueue.length === file.length) {
      this.finalupload(
        this.uploadQueue[0].file,
        this.uploadQueue[0].productIndex,
        this.uploadQueue[0].partIndex
      );
    }
  };

  private remove = (index: any, i: any) => {
    const rs = { ...this.state.formData.warrantyClaimDetails[i] };
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];

    const delfile = rs['picofpart'].splice(index, 1);

    rs['fileArray'].splice(index, 1);
    rs['tempfilearray'].splice(index, 1);
    rs['imagepreview'].splice(index, 1);

    rs['pictureofparts'].splice(index, 1);

    rs['indexImage']--;

    if (rs['fileArray'].length === 0) {
      rs['indexImage'] = 0;
    }

    warrantyClaimDetails[i].indexImage = rs['indexImage'];
    warrantyClaimDetails[i].count = rs['count'];
    this.setState({
      formData: {
        ...this.state.formData,

        warrantyClaimDetails: [...this.state.formData.warrantyClaimDetails]
      }
    });
  };
  private delete = (index: any, i: any, filename: any) => {
    const ref = { ...this.state.formData.warrantyClaimDetails[i] };
    const rs = { ...this.state.formData.warrantyClaimDetails[i] };
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];

    const delfile = filename;

    const formData = new FormData();
    formData.append('claimNumber', this.state.formData.claimNumber.toString());
    formData.append('fileName', delfile.toString());
    formData.append('index', index);
    formData.append('partNumber', rs['partNumber']);
    formData.append('invoiceNumber', rs['invoiceNumber'].toString());

    WarrantyClaimService.deletePicofpart(formData)
      .then(response => {
        rs['fileArray'].splice(index, 1);
        rs['tempfilearray'].splice(index, 1);
        rs['imagepreview'].splice(index, 1);
        rs['picofpart'].splice(index, 1);
        if (rs['pictureofparts'][index].spinner === 'success') {
          rs['count'] = rs['count'] - 1;
        }

        rs['pictureofparts'].splice(index, 1);

        rs['indexImage']--;

        if (rs['fileArray'].length === 0) {
          rs['indexImage'] = 0;
        }

        warrantyClaimDetails[i].indexImage = rs['indexImage'];
        warrantyClaimDetails[i].count = rs['count'];
        this.setState({
          formData: {
            ...this.state.formData,

            warrantyClaimDetails
          }
        });
      })
      .catch(error1 => {
        // console.log('picerror', error1);
      });
  };

  private finalupload = (file: any, k: number, i: any) => {
    return new Promise((resolve, reject) => {
      const uploadDetails = { ...this.state.formData.warrantyClaimDetails[i] };
      const warrantyClaimDetails = [
        ...this.state.formData.warrantyClaimDetails
      ];
      const formData = new FormData();
      formData.append(
        'accountNumber',
        this.state.formData.accountNumber.toString()
      );
      formData.append(
        'claimNumber',
        this.state.formData.claimNumber.toString()
      );
      formData.append('file', file);
      formData.append('index', k.toString());
      formData.append(
        'invoiceNumber',
        uploadDetails['invoiceNumber'].toString()
      );
      formData.append('partNumber', uploadDetails['partNumber']);
      WarrantyClaimService.getPicofpart(formData)
        .then(response => {
          resolve(response);
          const successFile = this.uploadQueue.shift();
          if (this.uploadQueue.length) {
            this.finalupload(
              this.uploadQueue[0].file,
              this.uploadQueue[0].productIndex,
              this.uploadQueue[0].partIndex
            );
          }

          uploadDetails['pictureofparts'][successFile.productIndex].spinner =
            'success';

          this.settingstatecount(
            i,
            uploadDetails['count'],
            'success',
            successFile.productIndex
          );
        })
        .catch(error => {
          const failureFile = this.uploadQueue.shift();
          if (this.uploadQueue.length) {
            this.finalupload(
              this.uploadQueue[0].file,
              this.uploadQueue[0].productIndex,
              this.uploadQueue[0].partIndex
            );
          }

          this.settingstatecountfailure(
            i,
            'failure',
            failureFile.productIndex,
            error.response.data.errorMessage
          );
        });
    });
  };
  private settingstatecountfailure = (
    partIndex: any,
    spinnerstatus: any,
    spinnerIndex: any,
    errormsg: any
  ) => {
    const uploadDetails = {
      ...this.state.formData.warrantyClaimDetails[partIndex]
    };
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    const errormessage =
      errormsg === 'IMG002'
        ? `${i18n.t('partClaim.invalidpic')}`
        : `${i18n.t('partClaim.delaypic')}`;
    uploadDetails['pictureofparts'][spinnerIndex].spinner = 'failure';
    uploadDetails['pictureofparts'][spinnerIndex].imgfail = errormessage;

    this.setState({
      formData: {
        ...this.state.formData,

        warrantyClaimDetails
      }
    });
  };

  private settingstatecount = (
    partIndex: any,
    countvalue: any,
    spinnerstatus: any,
    spinnerIndex: any
  ) => {
    const uploadDetails = {
      ...this.state.formData.warrantyClaimDetails[partIndex]
    };
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    uploadDetails['pictureofparts'][spinnerIndex].spinner = 'success';

    uploadDetails['count'] = warrantyClaimDetails[partIndex].count + 1;
    warrantyClaimDetails[partIndex].count = uploadDetails['count'];

    this.setState({
      formData: {
        ...this.state.formData,

        warrantyClaimDetails
      }
    });
  };
  public handleModelnumbersearch = (e: any) => {
    const { name, value } = e.target;
    const error = value.length > 30;
    this.setState({
      formData: {
        ...this.state.formData,

        modelNumber: e.target.value,
        modellist: false
      },
      errors: {
        ...this.state.errors,
        modelNumberInvalidError: error
      }
    });
    if (value.trim() !== '') {
      WarrantyClaimService.getModelnumber(value)

        .then(response => {
          const Modelnumberlist =
            response &&
            response['data']['models'].map((modellist: any) => modellist.name);

          this.setState({
            formData: {
              ...this.state.formData,

              ModelnumberList: Modelnumberlist
            }
          });
        })
        .catch(err => {
          // console.log(err, 'modelnumbererror');
        });
    } else {
      this.selectedModelnumber(value);
    }
  };
  private selectedModelnumber = (value: any) => {
    this.setState({
      formData: {
        ...this.state.formData,

        modelNumber: value,
        modellist: true
      }
    });
  };

  private handleSerialNumber = (event: any) => {
    const { name, value } = event.target;
    const error = value.length > 20 || value === '';
    this.setState({
      formData: {
        ...this.state.formData,

        serialNumber: event.target.value
      },
      errors: {
        ...this.state.errors,
        serialNumberInvalidError: error
      }
    });
  };

  private handlecustomercomplaint = (event: any) => {
    const { name, value } = event.target;

    const error =
      value.length > 80 ||
      !NonkeycharacterRegEx.test(value) ||
      !commentsRegEx.test(value) ||
      !/\S/.test(value);

    this.setState({
      formData: {
        ...this.state.formData,

        customerComplaint: event.target.value
      },
      errors: {
        ...this.state.errors,
        customerComplaintInvalidError: error
      }
    });
  };

  private handleServicePerformed = (event: any) => {
    const { name, value } = event.target;
    const error =
      value.length > 80 ||
      !NonkeycharacterRegEx.test(value) ||
      !commentsRegEx.test(value) ||
      !/\S/.test(value);

    this.setState({
      formData: {
        ...this.state.formData,

        servicePerformed: event.target.value
      },
      errors: {
        ...this.state.errors,
        servicePerformedInvalidError: error
      }
    });
  };
  private handlecustomerFirstName = (event: any) => {
    const { name, value } = event.target;

    const error = value
      ? !AlphaNumericspaceRegex.test(value) ||
        (value === '' &&
          this.state.fieldsForSelectedBrand['customer.firstName'][1] ===
            'required') ||
        value.length > 22
      : false;

    this.setState({
      formData: {
        ...this.state.formData,

        customer: {
          ...this.state.formData.customer,
          firstName: event.target.value
        }
      },
      errors: {
        ...this.state.errors,
        customerFirstNameInvalidError: error
      }
    });
  };
  private handlecustomerLastName = (event: any) => {
    const { name, value } = event.target;
    const error = value
      ? !AlphaNumericspaceRegex.test(value) ||
        (value === '' &&
          this.state.fieldsForSelectedBrand['customer.lastName'][1] ===
            'required') ||
        value.length > 22
      : false;

    this.setState({
      formData: {
        ...this.state.formData,

        customer: {
          ...this.state.formData.customer,
          lastName: event.target.value
        }
      },
      errors: {
        ...this.state.errors,
        customerLastNameInvalidError: error
      }
    });
  };
  private handleOriginalinvoice = (inv: ISelectOption, index: number) => {
    const customerState = { ...this.state.formData };
    const partState = { ...this.state.formData.warrantyClaimDetails[index] };

    const invnoerror = [...this.state.errors.partsDetailsInvalidList];

    const selectedPartDetails: IPartSelectedDetails[] =
      partState['partSelectedDetails'];

    const selectedInvoice = selectedPartDetails.filter(
      a => a.invoiceNumber === inv.invnum
    );
    // debugger;
    if (selectedInvoice && selectedInvoice.length > 0) {
      // console.log(inv.invnum);
      partState['invoiceNumber'] = inv.invnum;
      // console.log(partState['invoiceNumber']);
      if (partState['invoiceNumber'] > 0) {
        partState['quantity'] = 1;
      }

      partState['tempquantity'] = selectedInvoice[0].availableQuantity;
      partState['priceshow'] = this.currencyFormatter(
        selectedInvoice[0].unitPrice
      );
      partState['unitprice'] = this.currencyFormatter(
        selectedInvoice[0].unitPrice
      );
      partState['unitpricenum'] = selectedInvoice[0].unitPrice;
      partState['price'] = selectedInvoice[0].unitPrice;
      partState['mfg'] = selectedInvoice[0].manufacturerCode;
      partState['wholePartNumber'] =
        selectedInvoice[0].manufacturerCode +
        ' ' +
        partState['partNumber'].toUpperCase();

      partState['totalprice'] = selectedInvoice[0].unitPrice.toString();
      if (
        this.state.fieldsForSelectedBrand['part.purchaseDate'][1] === 'required'
      ) {
        WarrantyClaimService.getpurchaseDate(
          partState['partNumber'],
          inv.invnum
        )
          .then(response => {
            let purchaseDate: any;
            purchaseDate = response && response['data'];

            partState['orgpurchasedate'] = purchaseDate;
            warrantyClaimDetails[index] = partState;
            this.setState({
              formData: { ...customerState, warrantyClaimDetails }
            });
          })
          .catch(error1 => {
            // console.log(error1);
          });
      }
    }
    partState['InvoiceOption'] = {
      value: inv.invnum,
      label: inv.invnum,
      invnum: inv.invnum,
      isDisabled: inv.isDisabled,
      quantity: inv.quantity,
      unitPrice: inv.unitPrice
    };
    partState['tempquantity'] = inv.quantity;
    invnoerror[index].quantityInvalidError = false;

    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    warrantyClaimDetails[index] = partState;
    warrantyClaimDetails[index].InvoiceOption = partState['InvoiceOption'];
    this.setState({
      formData: { ...customerState, warrantyClaimDetails },
      errors: {
        ...this.state.errors,
        partsDetailsInvalidList: [...invnoerror]
      }
    });
    let error = false;
    let j;
    if (warrantyClaimDetails.length > 0) {
      for (j = 0; j < warrantyClaimDetails.length; j++) {
        if (j !== index) {
          if (warrantyClaimDetails[j].partNumber === partState['partNumber']) {
            if (
              warrantyClaimDetails[j].invoiceNumber ===
              partState['invoiceNumber']
            ) {
              error = true;

              partState['quantity'] = 0;
              partState['priceshow'] = '$0.00';
              partState['price'] = 0;
              partState['unitprice'] = '$0.00';
              partState['unitpricenum'] = 0;
              break;
            }
          }
        }
      }

      error
        ? (invnoerror[index].orginvoiceNumberInvalidError = error)
        : (invnoerror[index].orginvoiceNumberInvalidError = false);

      warrantyClaimDetails[index] = partState;
      this.setState({
        formData: { ...customerState, warrantyClaimDetails },
        errors: {
          ...this.state.errors,
          partsDetailsInvalidList: [...invnoerror]
        }
      });
    } else {
      invnoerror[index].orginvoiceNumberInvalidError = false;
      this.setState({
        formData: { ...customerState, warrantyClaimDetails },
        errors: {
          ...this.state.errors,
          partsDetailsInvalidList: [...invnoerror]
        }
      });
    }
  };

  private handleReplacementInvNo = (event: any, index: number) => {
    const { name, value } = event.target;
    const customerState = { ...this.state.formData };
    const partState = { ...this.state.formData.warrantyClaimDetails[index] };
    const nameSplit: any = name.split('.');
    partState[nameSplit[1]] = value;
    const warrantyClaimDetails = [...this.state.formData.warrantyClaimDetails];
    const reperrors = [...this.state.errors.partsDetailsInvalidList];

    warrantyClaimDetails[index] = partState;
    const error = !AplhanumerichypenRegEx.test(value) || value.length > 12;
    error
      ? (reperrors[index].RepinvNumberInvalidError = true)
      : (reperrors[index].RepinvNumberInvalidError = false);

    this.setState({
      formData: { ...customerState, warrantyClaimDetails },
      errors: {
        ...this.state.errors,
        partsDetailsInvalidList: [...reperrors]
      }
    });
  };
  private handleconsumeremail = (event: any) => {
    const { name, value } = event.target;
    const error =
      !emailcapsRegEx.test(value) ||
      value.length > 50 ||
      (value === '' &&
        this.state.fieldsForSelectedBrand['customer.email'][1] === 'required');

    this.setState({
      formData: {
        ...this.state.formData,

        customer: {
          ...this.state.formData.customer,
          email: event.target.value
        }
      },
      errors: {
        ...this.state.errors,
        consumerEmailError: error
      }
    });
  };
  private handleserviceremail = (event: any) => {
    const { name, value } = event.target;
    const error =
      !emailcapsRegEx.test(value) || value.length > 50 || value === '';

    this.setState({
      formData: {
        ...this.state.formData,

        customer: {
          ...this.state.formData.customer,
          servicerEmail: value
        }
      },
      errors: {
        ...this.state.errors,
        servicerEmailError: error
      }
    });
  };
  private handlecustomerphone = (event: any) => {
    const { name, value } = event.target;
    const phonetest = value
      ? value
          .match(/\d+/g)
          .join('')
          .replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3')
      : '';

    const error = value ? !UsphoneNumberRegEx.test(phonetest) : false;

    this.setState({
      formData: {
        ...this.state.formData,
        customer: {
          ...this.state.formData.customer,
          phone: phonetest
        }
      },
      errors: {
        ...this.state.errors,
        customerPhoneError: error
      }
    });
  };
  private handleservicerphone = (event: any) => {
    const { name, value } = event.target;
    const phonetest = value
      ? value
          .match(/\d+/g)
          .join('')
          .replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, '$1-$2-$3')
      : '';

    const error = value ? !UsphoneNumberRegEx.test(phonetest) : false;

    this.setState({
      formData: {
        ...this.state.formData,
        customer: {
          ...this.state.formData.customer,
          servicerPhone: phonetest
        }
      },
      errors: {
        ...this.state.errors,
        servicerphoneError: error
      }
    });
  };
  private handleConsumercity = (event: any) => {
    const { name, value } = event.target;
    const error =
      (value === '' &&
        this.state.fieldsForSelectedBrand['customer.city'][1] === 'required') ||
      value.length > 35;
    this.setState({
      formData: {
        ...this.state.formData,
        customer: {
          ...this.state.formData.customer,
          city: event.target.value
        }
      },
      errors: {
        ...this.state.errors,
        customercityInvalidError: error
      }
    });
  };
  private handleconsumerAddress = (event: any) => {
    const { name, value } = event.target;
    const error =
      (value === '' &&
        this.state.fieldsForSelectedBrand['customer.address'][1] ===
          'required') ||
      value.length > 35;
    this.setState({
      formData: {
        ...this.state.formData,
        customer: {
          ...this.state.formData.customer,
          address: event.target.value
        }
      },
      errors: {
        ...this.state.errors,
        customeraddressInvalidError: error
      }
    });
  };

  private handleConsumerpostal = (event: any) => {
    const { name, value } = event.target;
    let error;
    {
      env.REACT_APP_BASE_ENVIRONMENT === 'CA'
        ? (error = value ? !PostalCodeCARegex.test(value) : false)
        : (error = value ? !PostalCodeRegEx.test(value) : false);
    }

    this.setState({
      formData: {
        ...this.state.formData,
        customer: {
          ...this.state.formData.customer,
          postalcode: event.target.value
        }
      },
      errors: {
        ...this.state.errors,
        consumerpostalcodeInvalidError: error
      }
    });
  };

  private handlequantity = (event: any, index: any) => {
    // debugger;
    const { name, value } = event.target;
    const invalidChars = ['-', '+', 'e'];
    if (!invalidChars.includes(event.key) || event.which !== 8) {
      event.preventDefault();
      const partState = { ...this.state.formData.warrantyClaimDetails[index] };
      const quantityerror = [...this.state.errors.partsDetailsInvalidList];
      const customerState = { ...this.state.formData };

      const nameSplit: any = name.split('.');
      partState[nameSplit[1]] = value;
      const warrantyClaimDetails = [
        ...this.state.formData.warrantyClaimDetails
      ];

      const selectedPartDetails: IPartSelectedDetails[] =
        partState['partSelectedDetails'];

      const selectedInvoice = selectedPartDetails.filter(
        a => a.invoiceNumber === partState['InvoiceOption'].invnum
      );

      let pqprice;

      let error;

      if (selectedInvoice && selectedInvoice.length > 0) {
        value > selectedInvoice[0].availableQuantity ||
        value === 0 ||
        value === '' ||
        value === '0' ||
        value < 0 ||
        value.includes('.') ||
        value === '.' ||
        value === 'e'
          ? (error = true)
          : (pqprice = selectedInvoice[0].unitPrice);

        partState['price'] = pqprice * value;
        partState['priceshow'] = this.currencyFormatter(pqprice * value);
      }
      if (value > partState['tempquantity']) {
        // debugger;
        error = true;
        partState['price'] = warrantyClaimDetails[0].unitpricenum * value;
        partState['priceshow'] = this.currencyFormatter(
          warrantyClaimDetails[0].unitpricenum * value
        );
      }
      if (error === true && selectedInvoice.length > 0) {
        partState['tempquantity'] = selectedInvoice[0].availableQuantity;
        warrantyClaimDetails[index] = partState;
      }

      error
        ? (quantityerror[index].quantityInvalidError = error)
        : (quantityerror[index].quantityInvalidError = '');

      warrantyClaimDetails[index] = partState;

      this.setState({
        formData: {
          ...this.state.formData,

          warrantyClaimDetails: [...this.state.formData.warrantyClaimDetails]
        }
      });
      this.setState({
        formData: { ...customerState, warrantyClaimDetails },
        errors: {
          ...this.state.errors,
          partsDetailsInvalidList: [...quantityerror]
        }
      });
    }
  };
  public checkquantity = (e: any): boolean => {
    return e.keyCode === 8 || e.keyCode === 46 ? true : !isNaN(Number(e.key));
  };
  private handleRefNumber = (event: any) => {
    const { name, value } = event.target;
    const error = value ? value.length > 30 : false;
    this.setState({
      formData: {
        ...this.state.formData,
        refno: event.target.value
      },
      errors: {
        ...this.state.errors,
        refnoInvalidError: error
      }
    });
  };
  private handleincidentNumber = (event: any) => {
    const { name, value } = event.target;
    const error = value ? value.length > 15 : false;
    this.setState({
      formData: {
        ...this.state.formData,
        incidentNumber: event.target.value
      },
      errors: {
        ...this.state.errors,
        incidentNumberInvalidError: error
      }
    });
  };

  private handlehavureturnpart = (selectedOptionValue: any) => {
    this.setState({
      selectedhavureturn: {
        name: yesno.find(state => state.value === selectedOptionValue.label)
          ?.name,

        value: selectedOptionValue.value,
        label: selectedOptionValue.label
      }
    });
    const error = selectedOptionValue.value === 'N' ? true : false;
    this.setState({
      formData: {
        ...this.state.formData,

        haveureturnpart: selectedOptionValue.value
      },
      errors: {
        ...this.state.errors,
        haveureturnInvalidError: error
      }
    });
  };
  private formattedyesnoOptions = (statesList: IYesno[]): IOption[] => {
    return statesList.map(({ name, value }) => ({ label: name, value }));
  };
  private formattedyesnoreturnOptions = (statesList: IYesno[]): IOption[] => {
    return statesList.map(({ name, value }) => ({ label: name, value }));
  };
  private productTypesOptions = (productlist: IProductList[]): IOption[] => {
    return productlist.map(({ name, value }) => ({ label: name, value }));
  };
  private handlereqforreturn = (selectedOptionValue: any) => {
    this.setState({
      selectedreturntag: {
        name: yesno.find(state => state.value === selectedOptionValue.label)
          ?.name,

        value: selectedOptionValue.value,
        label: selectedOptionValue.label
      }
    });
    this.setState({
      formData: {
        ...this.state.formData,

        reqreturn: selectedOptionValue.value
      }
    });
  };
  private handlerproducttypes = (selectedOptionValue: any) => {
    this.setState({
      selectedproducttag: {
        name: productList.find(
          state => state.value === selectedOptionValue.label
        )?.name,

        value: selectedOptionValue.value,
        label: selectedOptionValue.label
      }
    });
    this.setState({
      formData: {
        ...this.state.formData,

        producttype: selectedOptionValue.value
      }
    });
  };
  private handlesupplierinvnum = (event: any) => {
    const { name, value } = event.target;
    const error = !AlphaNumericRegex.test(value);

    this.setState({
      formData: {
        ...this.state.formData,
        supplierinvnum: event.target.value
      },
      errors: {
        ...this.state.errors,
        supplierinvnumInvalidError: error
      }
    });
  };

  private formattedStateOptions = (statesList: IAddress[]): IOption[] => {
    return statesList.map(({ name, value }) => ({ label: name, value }));
  };

  private handleInputStateChange = (selectedOptionValue: any) => {
    if (selectedOptionValue) {
      this.setState({
        selectedState: {
          name:
            addressUSA.find(state => state.value === selectedOptionValue.value)
              ?.name ||
            addressCA.find(state => state.value === selectedOptionValue.value)
              ?.name,

          value: selectedOptionValue.value
        }
      });

      selectedOptionValue.value === 'NA'
        ? this.setState({
            formData: {
              ...this.state.formData,
              otherstate: true,
              stateCode: ''
            }
          })
        : this.setState({
            formData: {
              ...this.state.formData,
              otherstate: false,

              stateCode: selectedOptionValue.value,
              customer: {
                ...this.state.formData.customer,
                state: selectedOptionValue.label
              }
            }
          });
    }
  };
  private handletrackinglocation = (selectedValue: any) => {
    this.setState({
      selectedtrackinglocation: {
        name:
          locationCA.find(state => state.value === selectedValue.value)?.name ||
          locationUSA.find(state => state.value === selectedValue.value)?.name,

        value: selectedValue.value
      }
    });

    this.setState({
      formData: {
        ...this.state.formData,

        trackinglocation:
          this.state.formData.haveureturnpart === 'N' ? '' : selectedValue.value
      }
    });
  };
  private formattedLocationOptions = (
    locationList: ILocation[]
  ): ILoption[] => {
    return locationList.map(({ name, value }) => ({ label: name, value }));
  };
  private handletrackingNumber = (event: any) => {
    const { name, value } = event.target;

    const error =
      !AlphaNumericRegex.test(value) ||
      (value.length >= 1 && value.length < 8) ||
      value.length > 25;

    this.setState({
      formData: {
        ...this.state.formData,

        trackingnum: event.target.value
      },
      errors: {
        ...this.state.errors,
        trackingNumberInvalidError: error
      }
    });
  };

  private submitClaim = () => {
    // debugger;
    const damagClaimData = this.WarrantyFormData();

    if (damagClaimData.claimResubmit === '') {
      this.warrantyCallService(damagClaimData);
    } else {
      WarrantyClaimService.checkClaimSubmitted(damagClaimData).then(
        (result: any) => {
          //  console.log(result.data);
          if (result.data) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.submiterrormsg(
              'This claim has already been resubmitted. Please review status under "Claim Status".'
            );

            this.setState({
              formData: {
                ...this.state.formData,
                errormsg:
                  'This claim has already been resubmitted. Please review status under "Claim Status".',
                errormsgshow: true,
                finalsubmit: true
              }
            });
          } else {
            this.warrantyCallService(damagClaimData);
          }
        }
      );
    }
  };
  public render() {
    const { t } = this.props;

    const { state } = this;
    const { formData, brandSelect, selectedBrand } = state;

    // console.log(formData, 'Render Method');

    const defaultTheme = createMuiTheme();

    const theme = createMuiTheme({
      overrides: {
        MuiTooltip: {
          tooltip: {
            fontSize: '15px',
            color: 'black',
            backgroundColor: 'white'
          }
        }
      }
    });

    const colourStyles = {
      option: (styles: any) => {
        return {
          ...styles,

          padding: '15px',
          display: 'flex'
        };
      }
    };

    return (
      <>
        <form className="rp-warranty-claim-form" id="myForm">
          <>
            {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
              <AlertMessage
                display={
                  this.state.formData.brand === 'SAMSUNG' ||
                  formData.haveureturnpart === 'N'
                    ? true
                    : false
                }
                Message={t('partClaim.partmustbrtn')}
              />
            ) : (
              ''
            )}

            <AlertMessage
              display={
                this.state.formData.brand === 'PACKARD INC' ? true : false
              }
              Message={t('partClaim.packardmsg')}
            />

            <AlertMessage
              display={
                this.state.formData.brand === 'ULINE' || this.state.formData.brand === 'MARVEL' ? true : false
              }
              Message={t('partClaim.ulineandmarvelmsg')}
            />

            {this.checkfinalspinnerstatus() !== 'nothing' ? (
              <AlertMessage
                display={
                  formData.picloading === true || formData.picfailed === true
                    ? true
                    : false
                }
                Message={
                  formData.picloading === true
                    ? `${t('partClaim.waitmsg')}`
                    : `${t('partClaim.failedpic')}`
                }
                handleclose={this.spinnererrorremove}
              />
            ) : (
              ''
            )}

            {!this.isFormvalid() ? (
              ''
            ) : (
              <AlertMessage
                display={formData.errormsgshow === false ? false : true}
                handleclose={this.errormsgremove}
                Message={this.state.formData.errormsg}
              />
            )}

            <AlertMessage
              display={formData.finalsubmit === true ? true : false}
              Message={formData.errormsg}
              handleclose={this.finalsubmitremove}
            />
          </>

          <h4>{t('partClaim.brandinfo')}</h4>
          <div className="form-row row brand-info ">
            <div className="form-group  col-sm-12 col-md-8 col-lg-3 mb">
              <label className="form-control-placeholder" htmlFor="modelbrand">
                {t('partClaim.modelbrand')}:<span className="required">*</span>
              </label>
              <div className="form-control selectbrand-dropdown">
                <Select
                  renderClass={`general-input ${selectedBrand ? 'active' : ''}`}
                  options={brandSelect}
                  value={
                    this.state.selectedBrand
                      ? {
                          label: this.state.selectedBrand.label,
                          value: this.state.selectedBrand.value
                        }
                      : { label: 'Select Brand', value: '' }
                  }
                  optionsShown={4}
                  width={'126px'}
                  height={'40px'}
                  activeOption={selectedBrand}
                  isLoading={false}
                  onChange={option => {
                    this.onBrandSelected(option);
                  }}
                  hideSelectedOptions={true}
                  isSearchable={true}
                  placeholder="Select"
                  filterOption={(label, value) =>
                    label.label.toLowerCase().startsWith(value) ||
                    label.label.toUpperCase().startsWith(value)
                  }
                />
              </div>
            </div>
            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['accountNumber'] !== '' &&
              this.state.fieldsForSelectedBrand['accountNumber'] &&
              this.state.fieldsForSelectedBrand['accountNumber'][0] ===
                'true' && (
                <div className="form-group col-sm-12 col-md-4 col-lg-3  mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="customernumber"
                  >
                    {t('partClaim.customerNumber')}:
                  </label>
                  <input
                    className={`form-control grey-color ${
                      this.state.errors?.customerNumberError ? 'is-invalid' : ''
                    }`}
                    name="customerNumber"
                    type="text"
                    value={formData.accountNumber}
                    readOnly={true}
                  />

                  <span className="rp-warranty-input-error-internal">
                    {this.state.errors?.customerNumberError
                      ? 'Invalid customer number.'
                      : ''}
                  </span>
                </div>
              )}
            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['claimNumber'] !== '' &&
              this.state.fieldsForSelectedBrand['claimNumber'] &&
              this.state.fieldsForSelectedBrand['claimNumber'][0] ===
                'true' && (
                <div className="form-group col-sm-12  col-md-4 col-lg-3 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="claimnumber"
                  >
                    {t('partClaim.claimNumber')}:
                  </label>
                  <input
                    type="text"
                    className={`form-control grey-color${
                      this.state.errors?.claimNumberInvalidError
                        ? 'is-invalid'
                        : ''
                    }`}
                    name="claimNumber"
                    value={formData.claimNumber}
                    readOnly={true}
                  />

                  <p className="text-danger">
                    {this.state.errors?.claimNumberInvalidError
                      ? 'Invalid claim number.'
                      : ''}
                  </p>
                </div>
              )}

            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['referenceNumber'] !== '' &&
              this.state.fieldsForSelectedBrand['referenceNumber'] &&
              this.state.fieldsForSelectedBrand['referenceNumber'][0] ===
                'true' && (
                <div className="form-group col-sm-12 col-md-6 col-lg-3">
                  <label className="form-control-placeholder" htmlFor="refno">
                    {t('partClaim.refno')}:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['referenceNumber'] &&
                      this.state.fieldsForSelectedBrand[
                        'referenceNumber'
                      ][1] === 'required' && (
                        <span className="required">*</span>
                      )}
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      this.state.errors?.refnoInvalidError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.refno === '' &&
                          this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'referenceNumber'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'referenceNumber'
                          ][1] === 'required'
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="refno"
                    value={formData.refno}
                    onChange={this.handleRefNumber}
                  />

                  <span className="rp-warranty-input-error-internal">
                    {this.state.errors?.refnoInvalidError
                      ? formData.refno.length > 30
                        ? `${t('partClaim.maxref')}`
                        : `${t('partClaim.invref')}`
                      : ''}
                  </span>
                </div>
              )}
            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['incidentNumbers'] !== '' &&
              this.state.fieldsForSelectedBrand['incidentNumbers'] &&
              this.state.fieldsForSelectedBrand['incidentNumbers'][0] ===
                'true' && (
                <div className="form-group  col-sm-12 col-md-6 col-lg-3 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="incidentnumber"
                  >
                    {t('partClaim.incidentnumber')}:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['incidentNumbers'] &&
                      this.state.fieldsForSelectedBrand[
                        'incidentNumbers'
                      ][1] === 'required' && (
                        <span className="required">*</span>
                      )}
                  </label>
                  <input
                    className={`form-control ${
                      this.state.errors?.incidentNumberInvalidError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.incidentNumber.trim() === '' &&
                          this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'incidentNumbers'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'incidentNumbers'
                          ][1] === 'required'
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    type="text"
                    name="incidentnumber"
                    value={formData.incidentNumber}
                    onChange={this.handleincidentNumber}
                  />

                  <span className="rp-warranty-input-error-internal">
                    {this.state.errors?.incidentNumberInvalidError
                      ? formData.incidentNumber.length > 15
                        ? `${t('partClaim.incidentnumerror')}`
                        : // : formData.incidentNumber === ''
                          // ? `${t('partClaim.reqfield')}`
                          ''
                      : ''}
                  </span>
                </div>
              )}
            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['productTypes'] !== '' &&
              this.state.fieldsForSelectedBrand['productTypes'] &&
              this.state.fieldsForSelectedBrand['productTypes'][0] ===
                'true' && (
                <div className="form-group col-sm-12  col-md-4 col-lg-3  mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="producttype"
                  >
                    {t('partClaim.producttype')}:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['productTypes'] &&
                      this.state.fieldsForSelectedBrand['productTypes'][1] ===
                        'required' && <span className="required">*</span>}
                  </label>
                  <div
                    className={`form-control select-dropdown ${
                      this.state.errors?.producttypeInvalidError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.producttype === ''
                        ? 'form-control-error-border'
                        : ''
                    }`}
                  >
                    <CustomSelect
                      options={this.productTypesOptions(productList)}
                      className="custom-select"
                      onChange={option => this.handlerproducttypes(option)}
                      hideSelectedOptions={true}
                    />
                  </div>
                </div>
              )}
            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['modelNumber'] !== '' &&
              this.state.fieldsForSelectedBrand['modelNumber'] &&
              this.state.fieldsForSelectedBrand['modelNumber'][0] ===
                'true' && (
                <div className="form-group col-sm-12  col-md-4 col-lg-3  mb ">
                  <label
                    className="form-control-placeholder"
                    htmlFor="modelnumber"
                  >
                    {t('partClaim.modelNumber')}:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['modelNumber'] &&
                      this.state.fieldsForSelectedBrand['modelNumber'][1] ===
                        'required' && <span className="required">*</span>}
                  </label>
                  <input
                    className={`form-control ${
                      this.state.errors?.modelNumberInvalidError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.modelNumber.trim() === ''
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="modelNumber"
                    type="text"
                    value={formData.modelNumber}
                    onChange={this.handleModelnumbersearch}
                    autoComplete="off"
                  />
                  {formData.ModelnumberList.length >= 1 &&
                  formData.modellist === false ? (
                    <ul
                      className={`ul-list ${
                        formData.ModelnumberList.length <= 1 ? `ul-single` : ``
                      }`}
                    >
                      {formData.ModelnumberList.map(
                        (value: any, index: any) => (
                          <li onClick={e => this.selectedModelnumber(value)}>
                            {value}
                          </li>
                        )
                      )}
                    </ul>
                  ) : (
                    ''
                  )}

                  <span className="rp-warranty-input-error-internal">
                    {this.state.errors?.modelNumberInvalidError
                      ? formData.modelNumber === ''
                        ? `${t('partClaim.reqfield')}`
                        : `${t('partClaim.modelerror')}`
                      : ''}
                  </span>
                </div>
              )}
            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['serialNumber'] !== '' &&
              this.state.fieldsForSelectedBrand['serialNumber'] &&
              this.state.fieldsForSelectedBrand['serialNumber'][0] ===
                'true' && (
                <div className="form-group col-sm-12  col-md-4 col-lg-3  mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="serialNumber"
                  >
                    {t('partClaim.serialNumber')}:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['serialNumber'] &&
                      this.state.fieldsForSelectedBrand['serialNumber'][1] ===
                        'required' && <span className="required">*</span>}
                  </label>
                  <input
                    className={`form-control datefield ${
                      this.state.errors?.serialNumberInvalidError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.serialNumber.trim() === ''
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    name="serialNumber"
                    type="text"
                    value={formData.serialNumber}
                    onChange={this.handleSerialNumber}
                  />

                  <span className="rp-warranty-input-error-internal">
                    {this.state.errors?.serialNumberInvalidError
                      ? formData.serialNumber === ''
                        ? `${t('partClaim.reqfield')}`
                        : `${t('partClaim.maxtwentychar')}`
                      : ''}
                  </span>
                </div>
              )}

            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['installedDate'] !== '' &&
              this.state.fieldsForSelectedBrand['installedDate'] &&
              this.state.fieldsForSelectedBrand['installedDate'][0] ===
                'true' && (
                <div className="form-group col-sm-12  col-md-4 col-lg-3  mb ">
                  <label
                    className="form-control-placeholder"
                    htmlFor="installdate"
                  >
                    {formData.brand === 'RINNAI'
                      ? t('partClaim.unitinstallation')
                      : t('partClaim.dateOfinstall')}
                    {/* {t('partClaim.dateOfinstall')}: */}
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['installedDate'] &&
                      this.state.fieldsForSelectedBrand['installedDate'][1] ===
                        'required' && <span className="required">*</span>}
                  </label>
                  <div
                    className={`form-control datefield ${
                      this.state.errors?.partInstalledDateError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.partInstalledDate === null
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    tabIndex={0}
                  >
                    <DateSingle
                      onDateSelected={this.setInstalledDate}
                      date={formData.partInstalledDate}
                      maxdate={new Date()}
                    />
                  </div>

                  <p className="text-danger">
                    {this.state.errors?.partInstalledDateError
                      ? 'Invalid date.'
                      : ''}
                  </p>
                </div>
              )}

            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['failedDate'] !== '' &&
              this.state.fieldsForSelectedBrand['failedDate'] &&
              this.state.fieldsForSelectedBrand['failedDate'][0] === 'true' && (
                <div className="form-group col-sm-12  col-md-4 col-lg-3  mb ">
                  <label
                    className="form-control-placeholder"
                    htmlFor="dateoffailure"
                  >
                    {t('partClaim.dateOffailure')}:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['failedDate'] &&
                      this.state.fieldsForSelectedBrand['failedDate'][1] ===
                        'required' && <span className="required">*</span>}
                  </label>
                  <div
                    className={`form-control datefield ${
                      this.state.errors?.partFailDateError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.partFailedDate === null
                        ? 'form-control-error-border'
                        : this.state.fieldsForSelectedBrand[
                            'installedDate'
                          ][1] === 'required'
                        ? moment(formData.partFailedDate).isBefore(
                            formData.partInstalledDate
                          )
                          ? 'form-control-error-border'
                          : ''
                        : ''
                    }`}
                    tabIndex={0}
                  >
                    <DateSingle
                      onDateSelected={this.setFailedDate}
                      date={formData.partFailedDate}
                      installdate={this.state.formData.partInstalledDate}
                      maxdate={new Date()}
                    />
                  </div>

                  <span className="rp-warranty-input-error">
                    {this.state.errors?.partFailDateError
                      ? ` ${t('partClaim.faildateerror')}`
                      : ''}
                  </span>
                </div>
              )}

            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['repairDate'] !== '' &&
              this.state.fieldsForSelectedBrand['repairDate'] &&
              this.state.fieldsForSelectedBrand['repairDate'][0] === 'true' && (
                <div className="form-group col-sm-12  col-md-4 col-lg-3 mb ">
                  <label
                    className="form-control-placeholder"
                    htmlFor="dateofrepair"
                  >
                    {t('partClaim.dateOfrepair')}:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['repairDate'] &&
                      this.state.fieldsForSelectedBrand['repairDate'][1] ===
                        'required' && <span className="required">*</span>}
                  </label>
                  <div
                    className={`form-control datefield ${
                      this.state.errors?.partRepairDateError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.partRepairDate === null
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    tabIndex={0}
                  >
                    <DateSingle
                      onDateSelected={this.setRepairDate}
                      date={formData.partRepairDate}
                      installdate={
                        this.state.formData.partFailedDate ||
                        this.state.formData.partInstalledDate
                      }
                      maxdate={new Date()}
                    />
                  </div>

                  <span className="rp-warranty-input-error">
                    {this.state.errors?.partRepairDateError
                      ? this.state.fieldsForSelectedBrand[
                          'installedDate'
                        ][1] === 'required' &&
                        this.state.fieldsForSelectedBrand['failedDate'][1] ===
                          'required'
                        ? `${t('partClaim.repairdateerrorfailed')}`
                        : this.state.fieldsForSelectedBrand[
                            'installedDate'
                          ][1] === 'required'
                        ? `${t('partClaim.repairdateerrorins')}`
                        : ''
                      : ''}
                  </span>
                </div>
              )}

            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['customerComplaint'] !== '' &&
              this.state.fieldsForSelectedBrand['customerComplaint'] &&
              this.state.fieldsForSelectedBrand['customerComplaint'][0] ===
                'true' && (
                <div className="form-group  col-12 col-md-8 col-lg-6 mb">
                  <label
                    className="form-control-placeholder"
                    htmlFor="customercomplaint"
                  >
                    {t('partClaim.customerComplaint')} <span className='customer-complaint-note'>{t('partClaim.customerComplaintNote')}</span>:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['customerComplaint'] &&
                      this.state.fieldsForSelectedBrand[
                        'customerComplaint'
                      ][1] === 'required' && (
                        <span className="required">*</span>
                      )}
                  </label>
                  <input
                    className={`form-control ${
                      this.state.errors?.customerComplaintInvalidError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.customerComplaint === ''
                        ? 'form-control-error-border'
                        : ''
                    }`}
                    type="text"
                    name="customerComplaint"
                    value={formData.customerComplaint}
                    onChange={this.handlecustomercomplaint}
                  />

                  <div>
                    {this.state.errors?.customerComplaintInvalidError ? (
                      formData.customerComplaint === '' ? (
                        <span className="rp-warranty-input-error-internal">
                          {t('partClaim.reqfield')}
                        </span>
                      ) : !/\S/.test(formData.customerComplaint) ? (
                        <span className="rp-warranty-input-error-internal">
                          {t('partClaim.atleastchar')}
                        </span>
                      ) : formData.customerComplaint.length > 80 ? (
                        !commentsRegEx.test(formData.customerComplaint) ? (
                          <>
                            <span className="rp-warranty-input-error-internal">
                              {t('partClaim.maxeigchar')}
                            </span>
                            <p className="rp-warranty-input-error-internal">
                              {t('partClaim.tracknumerror')}(
                              {t('partClaim.noSymbols')})
                            </p>
                          </>
                        ) : (
                          <span className="rp-warranty-input-error-internal">
                            ({t('partClaim.maxeigchar')})
                          </span>
                        )
                      ) : (
                        <span className="rp-warranty-input-error-internal">
                          {t('partClaim.tracknumerror')}(
                          {t('partClaim.noSymbols')})
                        </span>
                      )
                    ) : (
                      <span className="input-info">
                        <i>
                          {' '}
                          ({t('partClaim.maxeigchar')})
                          {t('partClaim.tracknumerror')}(
                          {t('partClaim.noSymbols')})
                        </i>{' '}
                      </span>
                    )}
                  </div>
                </div>
              )}

            {this.state.fieldsForSelectedBrand &&
              this.state.fieldsForSelectedBrand['servicePerformed'] !== '' &&
              this.state.fieldsForSelectedBrand['servicePerformed'] &&
              this.state.fieldsForSelectedBrand['servicePerformed'][0] ===
                'true' && (
                <div
                  className={`form-group col-sm-12  col-md-8 col-lg-6  mb ${
                    this.state.errors?.customerComplaintInvalidError ? '' : ''
                  }`}
                >
                  <label
                    className="form-control-placeholder"
                    htmlFor="serviceperformed"
                  >
                    {t('partClaim.servicePerformed')}:
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['servicePerformed'] &&
                      this.state.fieldsForSelectedBrand[
                        'servicePerformed'
                      ][1] === 'required' &&
                      this.state.fieldsForSelectedBrand['serviceVerbage'] ===
                        '' && <span className="required">*</span>}
                  </label>
                  <input
                    className={`form-control  ${
                      this.state.errors?.servicePerformedInvalidError
                        ? 'is-invalid'
                        : this.state.formData.errormsgshow &&
                          formData.servicePerformed === ''
                        ? 'form-control-error-border'
                        : this.state.fieldsForSelectedBrand[
                            'servicePerformed'
                          ][0] === 'true' &&
                          this.state.fieldsForSelectedBrand[
                            'serviceVerbage'
                          ] !== ''
                        ? 'grey-color'
                        : ''
                    }`}
                    name="servicePerformed"
                    type="text"
                    value={formData.servicePerformed}
                    onChange={this.handleServicePerformed}
                    readOnly={
                      this.state.fieldsForSelectedBrand[
                        'servicePerformed'
                      ][0] === 'true' &&
                      this.state.fieldsForSelectedBrand['serviceVerbage'] !== ''
                        ? true
                        : false
                    }
                  />

                  {this.state.errors?.servicePerformedInvalidError ? (
                    formData.servicePerformed === '' ? (
                      <span className="rp-warranty-input-error-internal">
                        {t('partClaim.reqfield')}
                      </span>
                    ) : !/\S/.test(formData.servicePerformed) ? (
                      <span className="rp-warranty-input-error-internal">
                        {t('partClaim.atleastchar')}
                      </span>
                    ) : formData.servicePerformed.length > 80 ? (
                      !commentsRegEx.test(formData.servicePerformed) ? (
                        <>
                          <span className="rp-warranty-input-error-internal">
                            {t('partClaim.maxeigchar')}
                          </span>
                          <p className="rp-warranty-input-error-internal">
                            {t('partClaim.tracknumerror')}(
                            {t('partClaim.noSymbols')})
                          </p>
                        </>
                      ) : (
                        <span className="rp-warranty-input-error-internal">
                          ({t('partClaim.maxeigchar')})
                        </span>
                      )
                    ) : (
                      <span className="rp-warranty-input-error-internal">
                        {t('partClaim.tracknumerror')}(
                        {t('partClaim.noSymbols')})
                      </span>
                    )
                  ) : this.state.fieldsForSelectedBrand[
                      'servicePerformed'
                    ][0] === 'true' &&
                    this.state.fieldsForSelectedBrand['serviceVerbage'] ===
                      '' ? (
                    <span className="input-info">
                      <i>
                        {' '}
                        ({t('partClaim.maxeigchar')})
                        {t('partClaim.tracknumerror')}(
                        {t('partClaim.noSymbols')})
                      </i>{' '}
                    </span>
                  ) : (
                    ''
                  )}
                </div>
              )}
          </div>

          {/* PART Information */}
          {this.state.fieldsForSelectedBrand &&
            this.state.fieldsForSelectedBrand['part.quantity'] !== '' &&
            this.state.fieldsForSelectedBrand['part.quantity'] &&
            this.state.fieldsForSelectedBrand['part.quantity'][0] ===
              'true' && <h4>{t('partClaim.partinfo')}</h4>}
          {state.formData.warrantyClaimDetails.map((part, i) => (
            <div className={`d-flex`}>
              <div className={`brand-info row form-row mb-0  `} key={i}>
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.partNumber'] !== '' &&
                  this.state.fieldsForSelectedBrand['part.partNumber'] &&
                  this.state.fieldsForSelectedBrand['part.partNumber'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12  col-md-4 col-lg-3 mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="partnumber"
                      >
                        {t('partClaim.partNumber')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.partNumber'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.partNumber'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors.partsDetailsInvalidList[i] &&
                          this.state.errors.partsDetailsInvalidList[i]
                            .partNumberInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              part.partNumber === ''
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="part.partNumber"
                        type="text"
                        value={part.partNumber}
                        onChange={e => this.handlePartNumber(e, i)}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors.partsDetailsInvalidList[i] &&
                        this.state.errors.partsDetailsInvalidList[i]
                          .partNumberInvalidError
                          ? 'Invalid part number.'
                          : ''}
                      </span>
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.invoiceNumber'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['part.invoiceNumber'] &&
                  this.state.fieldsForSelectedBrand['part.invoiceNumber'][0] ===
                    'true' && (
                    <>
                      <div className="form-group col-sm-12 col-md-4 col-lg-3 mb">
                        <label
                          className="form-control-placeholder"
                          htmlFor="orginvoiceNumber"
                        >
                          {t('partClaim.orginvoiceNumber')}:
                          <span className="required">*</span>
                        </label>
                        <div
                          className={`form-control select-dropdown ${
                            this.state.errors.partsDetailsInvalidList[i] &&
                            this.state.errors.partsDetailsInvalidList[i]
                              ?.orginvoiceNumberInvalidError
                              ? 'is-invalid'
                              : this.state.formData.errormsgshow &&
                                (part.invoiceNumber === 0 ||
                                  part.invoiceNumber.toString() === '')
                              ? 'form-control-error-border'
                              : ''
                          }`}
                        >
                          <CustomSelect
                            options={part.partInvoiceList}
                            className="custom-select"
                            onChange={option => {
                              this.handleOriginalinvoice(option, i);
                            }}
                            value={part.InvoiceOption}
                            placeholder="Select Invoice"
                          />
                        </div>

                        <span className="rp-warranty-input-error-internal">
                          {this.state.errors.partsDetailsInvalidList[i] &&
                          this.state.errors.partsDetailsInvalidList[i]
                            ?.orginvoiceNumberInvalidError
                            ? `${t('partClaim.Invoiceerrormsg')}`
                            : ''}
                        </span>
                      </div>
                    </>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.quantity'] !== '' &&
                  this.state.fieldsForSelectedBrand['part.quantity'] &&
                  this.state.fieldsForSelectedBrand['part.quantity'][0] ===
                    'true' && (
                    <div className="form-group  col-sm-12  col-md-4 col-lg-2 mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="quantity"
                      >
                        {t('partClaim.quantity')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand['part.quantity'] &&
                          this.state.fieldsForSelectedBrand[
                            'part.quantity'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors.partsDetailsInvalidList[i] &&
                          this.state.errors.partsDetailsInvalidList[i]
                            ?.quantityInvalidError
                            ? 'is-invalid'
                            : (this.state.formData.errormsgshow &&
                                part.quantity === 0) ||
                              part.quantityshow
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="part.quantity"
                        type="number"
                        pattern="[1-9]*"
                        value={
                          part.quantity === 0 ||
                          part.quantity < 0 ||
                          Number(part.quantity) === 0
                            ? part.quantityshow
                            : Number(part.quantity).toFixed()
                        }
                        onChange={e => this.handlequantity(e, i)}
                        readOnly={
                          part.invoiceNumber === 0 ||
                          part.quantityshow ||
                          part.quantity.toString() === '-'
                            ? true
                            : false
                        }
                        onKeyDown={e =>
                          (e.keyCode === 69 ||
                            e.keyCode === 190 ||
                            e.keyCode === 173 ||
                            e.keyCode === 189 ||
                            e.keyCode === 109 ||
                            e.keyCode === 110 ||
                            e.key === '+') &&
                          e.preventDefault()
                        }
                      />

                      {this.state.errors.partsDetailsInvalidList[i] &&
                      this.state.errors.partsDetailsInvalidList[i]
                        ?.quantityInvalidError ? (
                        part.quantity === 0 ||
                        part.quantity.toString() === '' ||
                        part.quantity.toString() === '0' ||
                        part.quantity.toString() === '.' ||
                        part.quantity.toString().includes('.') ||
                        part.quantity.toString() === 'e' ? (
                          <span className="rp-warranty-input-error-internal">
                            {t('partClaim.atleastqnty')}
                          </span>
                        ) : (
                          <span className="rp-warranty-input-error-internal">
                            {t('partClaim.quantityerror')} {part.tempquantity}{' '}
                          </span>
                        )
                      ) : part.quantity > 0 ? (
                        <span className="input-info">
                          {t('partClaim.Availableqnty')}
                          {part.tempquantity}
                        </span>
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.price'] !== '' &&
                  this.state.fieldsForSelectedBrand['part.price'] &&
                  this.state.fieldsForSelectedBrand['part.price'][0] ===
                    'true' && (
                    <div className="form-group  col-sm-12  col-md-4 col-lg-2 mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="partprice"
                      >
                        {t('partClaim.unitprice')}:
                        {/* {this.state.fieldsForSelectedBrand &&
                        this.state.fieldsForSelectedBrand['part.price'] &&
                        this.state.fieldsForSelectedBrand['part.price'][1] ===
                          'required' && <span className="required">*</span>} */}
                      </label>
                      <input
                        className={`form-control ${
                          part.unitprice !== ''
                            ? 'form-control grey-color'
                            : 'form-control'
                        }`}
                        placeholder="$ XX.XX"
                        name="part.price"
                        type="text"
                        min={0}
                        readOnly={true}
                        value={
                          part.invoiceNumber.toString() === ''
                            ? ''
                            : part.unitprice
                        }
                      />
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.price'] !== '' &&
                  this.state.fieldsForSelectedBrand['part.price'] &&
                  this.state.fieldsForSelectedBrand['part.price'][0] ===
                    'true' && (
                    <div className="form-group  col-sm-12  col-md-4 col-lg-2 mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="partprice"
                      >
                        {t('partClaim.partprice')}:
                        {/* {this.state.fieldsForSelectedBrand &&
                        this.state.fieldsForSelectedBrand['part.price'] &&
                        this.state.fieldsForSelectedBrand['part.price'][1] ===
                          'required' && <span className="required">*</span>} */}
                      </label>
                      <input
                        className={`form-control ${
                          part.priceshow !== ''
                            ? 'form-control grey-color'
                            : 'form-control'
                        }`}
                        placeholder="$ XX.XX"
                        name="part.price"
                        type="text"
                        min={0}
                        readOnly={true}
                        value={
                          part.invoiceNumber.toString() === ''
                            ? ''
                            : part.priceshow
                        }
                      />
                    </div>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.purchaseDate'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['part.purchaseDate'] &&
                  this.state.fieldsForSelectedBrand['part.purchaseDate'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12  col-md-3 col-lg-3">
                      <label
                        className="form-control-placeholder"
                        htmlFor="orgpurchaseDate"
                      >
                        {t('partClaim.orgpurchaseDate')}:
                        {/* {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.purchaseDate'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.purchaseDate'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )} */}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.formData.errormsgshow &&
                          part.orgpurchasedate === ''
                            ? 'form-control-error-border'
                            : part.orgpurchasedate !== ''
                            ? 'grey-color'
                            : ''
                        }`}
                        name="part.purchasedate"
                        type="text"
                        value={part.orgpurchasedate}
                        readOnly={true}
                      />

                      <span className="rp-warranty-input-error">
                        {this.state.errors?.partPurchaseDateError
                          ? 'Invalid date.'
                          : ''}
                      </span>
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand[
                    'part.replacementInvoice'
                  ] !== '' &&
                  this.state.fieldsForSelectedBrand[
                    'part.replacementInvoice'
                  ] &&
                  this.state.fieldsForSelectedBrand[
                    'part.replacementInvoice'
                  ][0] === 'true' && (
                    <div
                      className={`form-group col-sm-12  col-md-4 col-lg-3 ${
                        this.state.errors.partsDetailsInvalidList[i]
                          ?.orginvoiceNumberInvalidError
                          ? `mt-part`
                          : ''
                      }`}
                    >
                      <label
                        className="form-control-placeholder"
                        htmlFor="replacementInvNo"
                      >
                        {t('partClaim.replacementInvNo')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.replacementInvoice'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.replacementInvoice'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors.partsDetailsInvalidList[i] &&
                          this.state.errors.partsDetailsInvalidList[i]
                            .RepinvNumberInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              part.replacementInvNo === ''
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="part.replacementInvNo"
                        type="text"
                        value={part.replacementInvNo}
                        onChange={e => this.handleReplacementInvNo(e, i)}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors.partsDetailsInvalidList[i] &&
                        this.state.errors.partsDetailsInvalidList[i]
                          .RepinvNumberInvalidError ? (
                          part.replacementInvNo === '' ? (
                            `${t('partClaim.reqfield')}`
                          ) : part.replacementInvNo.length > 12 &&
                            !AplhanumerichypenRegEx.test(
                              part.replacementInvNo
                            ) ? (
                            <>
                              <p>{t('partClaim.maxrep')}</p>
                              <p>
                                {t('partClaim.tracknumerror')}(
                                {t('partClaim.noSymbols')}){' '}
                              </p>
                            </>
                          ) : part.replacementInvNo.length > 12 ? (
                            `${t('partClaim.maxrep')}`
                          ) : !AplhanumerichypenRegEx.test(
                              part.replacementInvNo
                            ) ? (
                            <p>
                              {t('partClaim.tracknumerror')}(
                              {t('partClaim.noSymbols')}){' '}
                            </p>
                          ) : (
                            ''
                          )
                        ) : (
                          ''
                        )}
                      </span>
                    </div>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.replacementDate'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['part.replacementDate'] &&
                  this.state.fieldsForSelectedBrand[
                    'part.replacementDate'
                  ][0] === 'true' && (
                    <div className="form-group col-sm-12  col-md-4 col-lg-3 mb ">
                      <label className="form-control-placeholder" htmlFor="">
                        {t('partClaim.reppurchaseDate')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.replacementDate'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.replacementDate'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <div
                        className={`form-control datefield ${
                          this.state.formData.errormsgshow &&
                          part.partReplacementDate === null
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        tabIndex={0}
                      >
                        <DateSingle
                          onDateSelected={e => this.setRepDate(e, i)}
                          date={part.partReplacementDate}
                          maxdate={new Date()}
                        />
                      </div>
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.pictureOfPart'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['part.pictureOfPart'] &&
                  this.state.fieldsForSelectedBrand['part.pictureOfPart'][0] ===
                    'true' &&
                  part.unitpricenum >= 80 && (
                    <>
                      <div className="pic-wraper d-flex mb-20 ">
                        <label
                          className="form-control-placeholder photo-label"
                          htmlFor=""
                        >
                          {t('partClaim.picofpart')}:
                          {this.state.fieldsForSelectedBrand &&
                            this.state.fieldsForSelectedBrand[
                              'part.pictureOfPart'
                            ] &&
                            part.unitpricenum >= 80 && (
                              <span className="required">*</span>
                            )}
                        </label>
                        <span className="input-info pic-info">
                          {Number(part.quantity) > 1 ? (
                            <i>
                              {t('partClaim.minimumof')} {part.quantity}{' '}
                              {t('partClaim.pictures')}
                              {t('partClaim.and')} {t('partClaim.maximumof')}{' '}
                              {3 * part.quantity} {t('partClaim.pictures')}{' '}
                              {t('partClaim.allowed')}
                              {t('partClaim.maxsize')}
                            </i>
                          ) : (
                            <i>
                              {t('partClaim.minimumof')} {part.quantity}{' '}
                              {t('partClaim.picture')}
                              {t('partClaim.and')} {t('partClaim.maximumof')}{' '}
                              {3 * part.quantity} {t('partClaim.pictures')}{' '}
                              {t('partClaim.allowed')}
                              {t('partClaim.maxsize')}
                            </i>
                          )}
                        </span>

                        <div
                          className={`col-12 ${
                            part.price === 0 || part.priceshow === '$00.00'
                              ? 'pic-list-remove'
                              : this.state.formData.errormsgshow &&
                                part.count === 0
                              ? 'form-control-error-border-pic'
                              : ''
                          }`}
                        >
                          {this.checkspinner(i, Number(part.quantity)) ===
                          true ? (
                            ''
                          ) : (
                            <>
                              <div
                                className={`btn-file ${
                                  this.state.formData.errormsgshow &&
                                  part.count === 0
                                    ? 'error-pic'
                                    : ''
                                }`}
                              >
                                <MuiThemeProvider theme={theme}>
                                  <DropzoneAreaBase
                                    onAdd={e => this.uploadMultipleFiles(e, i)}
                                    filesLimit={
                                      3 * part.quantity -
                                      (part.showUploadModal === false
                                        ? 0
                                        : part.pictureofparts.length)
                                    }
                                    acceptedFiles={[
                                      'image/jpeg',
                                      'image/png',
                                      'image/jpg'
                                    ]}
                                    fileObjects={[]}
                                    maxFileSize={3146000}
                                    showAlerts={['error', 'info']}
                                    dropzoneText={`Drag and drop a picture here or click`}
                                    getDropRejectMessage={(
                                      file,
                                      type,
                                      size
                                    ) => {
                                      const errormessage =
                                        file.size > 3146000
                                          ? `Picture ${file.name} was rejected. Picture is too big. Size limit is 3MB.`
                                          : file.type !== 'image/jpeg' ||
                                            'image/png' ||
                                            'image/jpg'
                                          ? `Picture ${file.name} was rejected. Picture type not supported.`
                                          : `Maximum allowed number of pictures exceeded. Only ${3 *
                                              part.quantity -
                                              (part.showUploadModal === false
                                                ? 0
                                                : part.pictureofparts
                                                    .length)} allowed.`;
                                      return errormessage;
                                    }}
                                    getFileLimitExceedMessage={() =>
                                      `Maximum allowed number of pictures exceeded. Only ${3 *
                                        part.quantity -
                                        (part.showUploadModal === false
                                          ? 0
                                          : part.pictureofparts
                                              .length)} allowed.`
                                    }
                                  />
                                </MuiThemeProvider>
                              </div>

                              {this.state.formData.errormsgshow &&
                              part.count === 0 ? (
                                <span className={`pic-error`}>
                                  <i>
                                    {part.quantity} {t('partClaim.picturemsg')}
                                  </i>
                                </span>
                              ) : (
                                ''
                              )}
                            </>
                          )}
                        </div>
                        <div
                          className={`${
                            part.showUploadModal === true
                              ? ' eachfile-wraper'
                              : 'pic-list-remove'
                          }`}
                        >
                          {part.picofpart.map((name: any, index: any) => (
                            <div className="each-file">
                              <div className="pic-namewrapper">
                                <img
                                  src={part.imagepreview[index].toString()}
                                  className="pic-width"
                                />
                                {name}
                              </div>

                              <div className="w-10">
                                {part.pictureofparts.length >= 1 ? (
                                  <>
                                    {part.pictureofparts[index].spinner ===
                                    'start' ? (
                                      <HalfCircleSpinner
                                        color="#0b4da2"
                                        size={20}
                                        style={{
                                          marginRight: '8px',
                                          display: 'inline-block',
                                          padding: '0 10px 0 10px'
                                        }}
                                      />
                                    ) : (
                                      ''
                                    )}
                                  </>
                                ) : (
                                  ''
                                )}
                              </div>

                              <div className="success-wraper">
                                {part.pictureofparts[index].spinner ===
                                'success' ? (
                                  <div>
                                    <MuiThemeProvider theme={theme}>
                                      <Tooltip
                                        title={t('partClaim.photouploaded')}
                                        placement="bottom"
                                      >
                                        <i className="rpds rpds-check-circle success" />
                                      </Tooltip>
                                    </MuiThemeProvider>
                                    <MuiThemeProvider theme={theme}>
                                      <Tooltip
                                        title={t('partClaim.photodelete')}
                                        placement="bottom"
                                      >
                                        <button
                                          className="deleteicon"
                                          type="button"
                                        >
                                          <DeleteIcon
                                            onClick={e =>
                                              this.delete(
                                                index,
                                                i,
                                                part.picofpart[index]
                                              )
                                            }
                                          />
                                        </button>
                                      </Tooltip>
                                    </MuiThemeProvider>
                                  </div>
                                ) : (
                                  ''
                                )}

                                {part.pictureofparts[index].spinner ===
                                'failure' ? (
                                  <>
                                    <MuiThemeProvider theme={theme}>
                                      <Tooltip
                                        title={
                                          part.pictureofparts[index].imgfail
                                        }
                                        placement="bottom"
                                      >
                                        <i className="rpds rpds-error" />
                                      </Tooltip>
                                    </MuiThemeProvider>
                                    <MuiThemeProvider theme={theme}>
                                      <Tooltip
                                        title={t('partClaim.photoremove')}
                                        placement="bottom"
                                      >
                                        <i
                                          className="rpds rpds-close"
                                          onClick={e => this.remove(index, i)}
                                        />
                                      </Tooltip>
                                    </MuiThemeProvider>
                                  </>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
              </div>
              {this.state.fieldsForSelectedBrand &&
                this.state.fieldsForSelectedBrand['part.quantity'] !== '' &&
                this.state.fieldsForSelectedBrand['part.quantity'] &&
                this.state.fieldsForSelectedBrand['part.quantity'][0] ===
                  'true' && (
                  <>
                    {state.formData.warrantyClaimDetails.length > 1 && (
                      <div className={`remove-button pd-delete`}>
                        <div className="rp-delete ">
                          <MuiThemeProvider theme={theme}>
                            <Tooltip
                              title={t('partClaim.photodelete')}
                              placement="bottom"
                            >
                              <button
                                className="primary-button d-flex"
                                onClick={e => {
                                  e.preventDefault();
                                  this.removePart(i);
                                }}
                              >
                                {/* <span>{t('partClaim.Remove')}</span>
                            <span className="rpds-close" /> */}
                                {/* <i className="icon-trash"/> */}
                                <DeleteIcon />
                                {/* <img src={deleteIcon} alt="deleteIcon" 
                                             /> */}
                              </button>
                            </Tooltip>
                          </MuiThemeProvider>
                        </div>
                      </div>
                    )}
                  </>
                )}
            </div>
          ))}
          {this.state.fieldsForSelectedBrand &&
            this.state.fieldsForSelectedBrand['part.quantity'] !== '' &&
            this.state.fieldsForSelectedBrand['part.quantity'] &&
            this.state.fieldsForSelectedBrand['part.quantity'][0] ===
              'true' && (
              <div className="mb add-button">
                {!this.props.RSClaimDetails && (
                  <Button onClick={this.addPart} variant="contained">
                    {t('partClaim.addPart')}
                  </Button>
                )}
              </div>
            )}

          {this.state.fieldsForSelectedBrand &&
            this.state.fieldsForSelectedBrand['part.isReturned'] !== '' &&
            this.state.fieldsForSelectedBrand['part.isReturned'] &&
            this.state.fieldsForSelectedBrand['part.isReturned'][0] ===
              'true' && (
              <div className="form-row row brand-info mb-20">
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.isReturned'] !== '' &&
                  this.state.fieldsForSelectedBrand['part.isReturned'] &&
                  this.state.fieldsForSelectedBrand['part.isReturned'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12  col-md-4 col-lg-3  mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="isreturned"
                      >
                        {t('partClaim.haveureturnpart')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.isReturned'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.isReturned'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <div
                        className={`form-control select-dropdown ${
                          this.state.errors?.haveureturnInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.haveureturnpart === ''
                            ? 'form-control-error-border'
                            : ''
                        }`}
                      >
                        <CustomSelect
                          options={this.formattedyesnoOptions(yesno)}
                          className="custom-select"
                          onChange={option => {
                            this.handlehavureturnpart(option);
                          }}
                        />
                      </div>

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.haveureturnInvalidError
                          ? `${t('partClaim.partmustbrtn')}`
                          : ''}
                      </span>
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand[
                    'part.returnTrackingInfo'
                  ] !== '' &&
                  this.state.fieldsForSelectedBrand[
                    'part.returnTrackingInfo'
                  ] &&
                  this.state.fieldsForSelectedBrand[
                    'part.returnTrackingInfo'
                  ][0] === 'true' && (
                    <div className="form-group col-sm-12  col-md-4 col-lg-3  mb margin-tracking">
                      <label className="form-control-placeholder" htmlFor="">
                        {t('partClaim.tracking')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.returnTrackingInfo'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.returnTrackingInfo'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control  ${
                          this.state.errors?.trackingNumberInvalidError
                            ? 'is-invalid'
                            : formData.haveureturnpart === 'N'
                            ? 'grey-color-light'
                            : ''
                        }`}
                        name="trackingnum"
                        type="text"
                        value={formData.trackingnum}
                        onChange={this.handletrackingNumber}
                        readOnly={
                          formData.haveureturnpart === 'N' ? true : false
                        }
                        autoComplete="off"
                      />

                      {this.state.errors?.trackingNumberInvalidError ? (
                        formData.trackingnum.length >= 1 &&
                        formData.trackingnum.length < 8 ? (
                          !AlphaNumericRegex.test(formData.trackingnum) ? (
                            <>
                              <p className="rp-warranty-input-error-internal">
                                {t('partClaim.minofeightnospl')}
                              </p>
                              <p className="rp-warranty-input-error-internal">
                                {t('partClaim.tracknumerror')}(
                                {t('partClaim.noSymbols')})
                              </p>
                            </>
                          ) : (
                            <p className="rp-warranty-input-error-internal">
                              {t('partClaim.trackingmsgmin')}
                            </p>
                          )
                        ) : !AlphaNumericRegex.test(formData.trackingnum) &&
                          formData.trackingnum.length > 25 ? (
                          <>
                            <p className="rp-warranty-input-error-internal">
                              {t('partClaim.maxofnospl')}
                            </p>
                            <p className="rp-warranty-input-error-internal">
                              {t('partClaim.tracknumerror')}(
                              {t('partClaim.noSymbols')})
                            </p>
                          </>
                        ) : formData.trackingnum.length > 25 ? (
                          <p className="rp-warranty-input-error-internal">
                            {t('partClaim.trackingmsgmax')}
                          </p>
                        ) : formData.trackingnum === '' ? (
                          <p className="rp-warranty-input-error-internal">
                            {t('partClaim.reqfield')}
                          </p>
                        ) : (
                          <p className="rp-warranty-input-error-internal">
                            {t('partClaim.tracknumerror')}(
                            {t('partClaim.noSymbols')})
                          </p>
                        )
                      ) : (
                        <span className="input-info">
                          {/* {`(${t('partClaim.noSymbols')})`} */}
                          <i>{t('partClaim.trackingmsg')}</i>
                        </span>
                      )}
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand[
                    'part.returnTrackingLocation'
                  ] !== '' &&
                  this.state.fieldsForSelectedBrand[
                    'part.returnTrackingLocation'
                  ] &&
                  this.state.fieldsForSelectedBrand[
                    'part.returnTrackingLocation'
                  ][0] === 'true' && (
                    <div className="form-group col-sm-12  col-md-4 col-lg-3  mb">
                      <label className="form-control-placeholder" htmlFor="">
                        {t('partClaim.trackinglocation')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.returnTrackingLocation'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.returnTrackingLocation'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <div
                        className={`form-control select-dropdown ${
                          formData.haveureturnpart === 'N'
                            ? 'grey-color-light'
                            : this.state.formData.errormsgshow &&
                              formData.trackinglocation === ''
                            ? 'form-control-error-border'
                            : ''
                        }`}
                      >
                        <Select
                          options={
                            env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                              ? this.formattedLocationOptions(locationCA)
                              : this.formattedLocationOptions(locationUSA)
                          }
                          onChange={option =>
                            this.handletrackinglocation(option)
                          }
                          placeholder={'Select Location'}
                          isDisabled={
                            formData.haveureturnpart === 'N' ? true : false
                          }
                          hideSelectedOptions={true}
                          filterOption={(label, value) =>
                            label.label.toLowerCase().startsWith(value) ||
                            label.label.toUpperCase().startsWith(value)
                          }
                          className="custom-select"
                        />
                      </div>

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.trackinglocationInvalidError ? (
                          formData.trackinglocation.length > 25 ? (
                            !AlphaNumerictrackinglocationRegex.test(
                              formData.trackinglocation
                            ) ? (
                              <>
                                <p className="rp-warranty-input-error-internal">
                                  {t('partClaim.trackingmsgmax')}
                                </p>
                                <p className="rp-warranty-input-error-internal">
                                  {t('partClaim.tracknumerror')}(
                                  {t('partClaim.noSymbols')})
                                </p>
                              </>
                            ) : (
                              <p className="rp-warranty-input-error-internal">
                                {t('partClaim.trackingmsgmax')}
                              </p>
                            )
                          ) : formData.trackinglocation === '' ? (
                            <p className="rp-warranty-input-error-internal">
                              {t('partClaim.reqfield')}
                            </p>
                          ) : (
                            <p className="rp-warranty-input-error-internal">
                              {t('partClaim.tracknumerror')}(
                              {t('partClaim.noSymbols')})
                            </p>
                          )
                        ) : (
                          ''
                        )}
                      </span>
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['part.requestReturnTag'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['part.requestReturnTag'] &&
                  this.state.fieldsForSelectedBrand[
                    'part.requestReturnTag'
                  ][0] === 'true' && (
                    <div className="form-group col-sm-12  col-md-4 col-lg-3  mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="requestforreturn"
                      >
                        {t('partClaim.requestforreturn')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.requestReturnTag'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.requestReturnTag'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <div
                        className={`form-control select-dropdown ${
                          this.state.errors?.reqreturnInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.reqreturn === ''
                            ? 'form-control-error-border'
                            : ''
                        }`}
                      >
                        <CustomSelect
                          options={this.formattedyesnoreturnOptions(yesno)}
                          className="custom-select"
                          onChange={option => this.handlereqforreturn(option)}
                          hideSelectedOptions={true}
                        />
                      </div>

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.reqforreturnInvalidError
                          ? `${t('partClaim.reqfreturn')} (y/n)`
                          : ''}
                      </span>
                    </div>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand[
                    'part.supplierInvoiceNumber'
                  ] !== '' &&
                  this.state.fieldsForSelectedBrand[
                    'part.supplierInvoiceNumber'
                  ] &&
                  this.state.fieldsForSelectedBrand[
                    'part.supplierInvoiceNumber'
                  ][0] === 'true' && (
                    <div className="form-group col-sm-12  col-md-4 col-lg-3  mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="supplierinvnum"
                      >
                        {t('partClaim.supplierInv')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'part.supplierInvoiceNumber'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'part.supplierInvoiceNumber'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control  ${
                          this.state.errors?.supplierinvnumInvalidError
                            ? 'is-invalid'
                            : ''
                        }`}
                        name="supplierInv"
                        type="text"
                        value={formData.supplierinvnum}
                        onChange={this.handlesupplierinvnum}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.supplierinvnumInvalidError
                          ? 'Invalid supplier invoice.'
                          : ''}
                      </span>
                    </div>
                  )}
              </div>
            )}

          {(this.state.fieldsForSelectedBrand &&
            this.state.fieldsForSelectedBrand['customer.firstName'] !== '' &&
            this.state.fieldsForSelectedBrand['customer.firstName'] &&
            this.state.fieldsForSelectedBrand['customer.firstName'][0] ===
              'true') ||
          (this.state.fieldsForSelectedBrand &&
            this.state.fieldsForSelectedBrand['customer.address'] !== '' &&
            this.state.fieldsForSelectedBrand['customer.address'] &&
            this.state.fieldsForSelectedBrand['customer.address'][0] ===
              'true') ? (
            <h4>{t('partClaim.customerinfo')}</h4>
          ) : (
            ''
          )}
          {this.state.fieldsForSelectedBrand &&
            this.state.fieldsForSelectedBrand['customer.firstName'] !== '' &&
            this.state.fieldsForSelectedBrand['customer.firstName'] &&
            this.state.fieldsForSelectedBrand['customer.firstName'][0] ===
              'true' && (
              <div className="form-row row brand-info ">
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['customer.firstName'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['customer.firstName'] &&
                  this.state.fieldsForSelectedBrand['customer.firstName'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12 col-md-3  col-lg-3  mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="customerFirstName"
                      >
                        {t('partClaim.customerFirstName')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'customer.firstName'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'customer.firstName'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors?.customerFirstNameInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.customer.firstName.trim() === '' &&
                              this.state.fieldsForSelectedBrand[
                                'customer.firstName'
                              ][1] === 'required'
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="customer.firstName"
                        type="text"
                        value={formData.customer.firstName}
                        onChange={this.handlecustomerFirstName}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.customerFirstNameInvalidError ? (
                          formData.customer.firstName.length > 22 &&
                          !AlphaNumericspaceRegex.test(
                            formData.customer.firstName
                          ) ? (
                            <>
                              <p>{t('partClaim.cusfirnameerror')}</p>
                              <p>
                                {' '}
                                {t('partClaim.tracknumerror')}(
                                {t('partClaim.noSymbols')})
                              </p>
                            </>
                          ) : formData.customer.firstName === '' &&
                            this.state.fieldsForSelectedBrand[
                              'customer.firstName'
                            ][1] === 'required' ? (
                            ` ${t('partClaim.cusfirname')}`
                          ) : !AlphaNumericspaceRegex.test(
                              formData.customer.firstName
                            ) ? (
                            <p>
                              {' '}
                              {t('partClaim.tracknumerror')}(
                              {t('partClaim.noSymbols')})
                            </p>
                          ) : formData.customer.firstName.length > 22 ? (
                            ` ${t('partClaim.cusfirnameerror')}`
                          ) : (
                            ''
                          )
                        ) : (
                          ''
                        )}
                      </span>
                    </div>
                  )}
                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['customer.lastName'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['customer.lastName'] &&
                  this.state.fieldsForSelectedBrand['customer.lastName'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12 col-md-3  col-lg-3  mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="customerlastname"
                      >
                        {t('partClaim.customerLastName')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'customer.lastName'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'customer.lastName'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors?.customerLastNameInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.customer.lastName.trim() === '' &&
                              this.state.fieldsForSelectedBrand[
                                'customer.lastName'
                              ][1] === 'required'
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="customer.lastName"
                        type="text"
                        value={formData.customer.lastName}
                        onChange={this.handlecustomerLastName}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.customerLastNameInvalidError ? (
                          formData.customer.lastName.length > 22 &&
                          !AlphaNumericspaceRegex.test(
                            formData.customer.lastName
                          ) ? (
                            <>
                              <p>{t('partClaim.cuslasnameerror')}</p>
                              <p>
                                {' '}
                                {t('partClaim.tracknumerror')}(
                                {t('partClaim.noSymbols')})
                              </p>
                            </>
                          ) : formData.customer.lastName === '' &&
                            this.state.fieldsForSelectedBrand[
                              'customer.lastName'
                            ][1] === 'required' ? (
                            ` ${t('partClaim.cusfirname')}`
                          ) : !AlphaNumericspaceRegex.test(
                              formData.customer.lastName
                            ) ? (
                            <p>
                              {' '}
                              {t('partClaim.tracknumerror')}(
                              {t('partClaim.noSymbols')})
                            </p>
                          ) : formData.customer.lastName.length > 22 ? (
                            ` ${t('partClaim.cuslasnameerror')}`
                          ) : (
                            ''
                          )
                        ) : (
                          ''
                        )}
                      </span>
                    </div>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['customer.address'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['customer.address'] &&
                  this.state.fieldsForSelectedBrand['customer.address'][0] ===
                    'true' && (
                    <div className="form-group col-12  col-md-6  col-lg-6 mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="customeraddress"
                      >
                        {t('partClaim.customerAddress')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'customer.address'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'customer.address'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors?.customeraddressInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.customer.address.trim() === '' &&
                              this.state.fieldsForSelectedBrand[
                                'customer.address'
                              ][1] === 'required'
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="customer.address"
                        type="text"
                        value={formData.customer.address}
                        onChange={this.handleconsumerAddress}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.customeraddressInvalidError
                          ? formData.customer.address === '' &&
                            this.state.fieldsForSelectedBrand[
                              'customer.address'
                            ][1] === 'required'
                            ? `${t('partClaim.reqfield')}`
                            : formData.customer.address.length > 35
                            ? `${t('partClaim.cusaddresserror')}`
                            : ''
                          : ''}
                      </span>
                    </div>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['customer.city'] !== '' &&
                  this.state.fieldsForSelectedBrand['customer.city'] &&
                  this.state.fieldsForSelectedBrand['customer.city'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12 col-md-3  col-lg-3 mb">
                      <label className="form-control-placeholder" htmlFor="">
                        {t('partClaim.customerCity')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand['customer.city'] &&
                          this.state.fieldsForSelectedBrand[
                            'customer.city'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors?.customercityInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.customer.city.trim() === '' &&
                              this.state.fieldsForSelectedBrand[
                                'customer.city'
                              ][1] === 'required'
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="customer.city"
                        type="text"
                        value={formData.customer.city}
                        onChange={this.handleConsumercity}
                        autoComplete="off"
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.customercityInvalidError
                          ? formData.customer.city === '' &&
                            this.state.fieldsForSelectedBrand[
                              'customer.city'
                            ][1] === 'required'
                            ? `${t('partClaim.reqfield')}`
                            : formData.customer.city.length > 35
                            ? `${t('partClaim.cusaddresserror')}`
                            : ''
                          : ''}
                      </span>
                    </div>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['customer.state'] !== '' &&
                  this.state.fieldsForSelectedBrand['customer.state'] &&
                  this.state.fieldsForSelectedBrand['customer.state'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12 col-md-6 col-lg-3">
                      <label
                        className="form-control-placeholder"
                        htmlFor="consumerprovince"
                      >
                        {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                          ? t('partClaim.consumerProvince')
                          : t('partClaim.consumerState')}
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand['customer.state'] &&
                          this.state.fieldsForSelectedBrand[
                            'customer.state'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <div
                        className={`form-control select-dropdown ${
                          this.state.errors?.customerstateInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.stateCode === '' &&
                              this.state.fieldsForSelectedBrand[
                                'customer.state'
                              ] &&
                              this.state.fieldsForSelectedBrand[
                                'customer.state'
                              ][1] === 'required'
                            ? 'form-control-error-border'
                            : ''
                        }`}
                      >
                        <Select
                          ref={ref => {
                            this.selectRef = ref;
                          }}
                          value={
                            this.state.selectedState
                              ? {
                                  label: this.state.selectedState.name,
                                  value: this.state.selectedState.name
                                }
                              : {
                                  label:
                                    env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                                      ? 'Select Province'
                                      : 'Select State',
                                  value: ''
                                }
                          }
                          options={
                            env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                              ? addressCA.map(({ name, value }) => ({
                                  label: name,
                                  value
                                }))
                              : addressUSA.map(({ name, value }) => ({
                                  label: name,
                                  value
                                }))
                          }
                          onChange={option =>
                            this.handleInputStateChange(option)
                          }
                          placeholder={
                            env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                              ? 'Select Province'
                              : 'Select State'
                          }
                          hideSelectedOptions={true}
                          filterOption={(label, value) =>
                            label.label.toLowerCase().startsWith(value) ||
                            label.label.toUpperCase().startsWith(value)
                          }
                          className="custom-select"
                        />
                      </div>

                      <span className="rp-warranty-input-error">
                        {this.state.errors?.consumerprovinceError
                          ? 'Invalid State.'
                          : ''}
                      </span>
                    </div>
                  )}
                {this.state.formData.otherstate ? (
                  <>
                    {this.state.fieldsForSelectedBrand &&
                      this.state.fieldsForSelectedBrand['customer.state'] !==
                        '' &&
                      this.state.fieldsForSelectedBrand['customer.state'] &&
                      this.state.fieldsForSelectedBrand['customer.state'][0] ===
                        'true' && (
                        <div className="form-group col-sm-12 col-md-6  mb">
                          <label
                            className="form-control-placeholder"
                            htmlFor="customerPhone"
                          >
                            {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                              ? t('partClaim.consumerProvince')
                              : t('partClaim.consumerState')}
                            {this.state.fieldsForSelectedBrand &&
                              this.state.fieldsForSelectedBrand[
                                'customer.state'
                              ] &&
                              this.state.fieldsForSelectedBrand[
                                'customer.state'
                              ][1] === 'required' && (
                                <span className="required">*</span>
                              )}
                          </label>
                          <input
                            className={`form-control ${
                              this.state.errors?.stateInvaliderror
                                ? 'is-invalid'
                                : this.state.formData.errormsgshow &&
                                  formData.stateCode === '' &&
                                  this.state.fieldsForSelectedBrand[
                                    'customer.state'
                                  ][1] === 'required'
                                ? 'form-control-error-border'
                                : ''
                            }`}
                            name="state"
                            type="text"
                            placeholder={
                              env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                                ? 'Enter Province'
                                : 'Enter State'
                            }
                            max={2}
                            value={formData.stateCode}
                            onChange={this.handleotherstate}
                          />

                          {this.state.errors?.stateInvaliderror ? (
                            <span className="rp-warranty-input-error-internal">
                              <i> {t('partClaim.statevalid')}</i>
                            </span>
                          ) : (
                            <span className="input-info">
                              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                                <i>
                                  [{t('partClaim.maxlenstate')} (Alberta, AB)]
                                </i>
                              ) : (
                                <i>
                                  {' '}
                                  [{t('partClaim.maxlenstate')} (NewYork, NY)]
                                </i>
                              )}
                            </span>
                          )}
                        </div>
                      )}
                  </>
                ) : (
                  ''
                )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['customer.zipCode'] !==
                    '' &&
                  this.state.fieldsForSelectedBrand['customer.zipCode'] &&
                  this.state.fieldsForSelectedBrand['customer.zipCode'][0] ===
                    'true' && (
                    <div className="form-group  col-sm-12 col-md-3  col-lg-3 mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="consumerpostal"
                      >
                        {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                          ? t('partClaim.consumerpostalca')
                          : t('partClaim.consumerpostal')}

                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand[
                            'customer.zipCode'
                          ] &&
                          this.state.fieldsForSelectedBrand[
                            'customer.zipCode'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors?.consumerpostalcodeInvalidError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.customer.postalcode.trim() === '' &&
                              this.state.fieldsForSelectedBrand[
                                'customer.zipCode'
                              ][1] === 'required'
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        placeholder={
                          env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                            ? 'x0x 0x0'
                            : 'xxxxx-xxxx (or) xxxxx'
                        }
                        name="consumerpostal"
                        type="text"
                        value={formData.customer.postalcode}
                        onChange={this.handleConsumerpostal}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.consumerpostalcodeInvalidError
                          ? formData.customer.postalcode === '' &&
                            this.state.fieldsForSelectedBrand[
                              'customer.zipCode'
                            ][1] === 'required'
                            ? `${t('partClaim.reqfield')}`
                            : env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                            ? t('partClaim.postalcodeca')
                            : t('partClaim.postalcode')
                          : ''}
                      </span>
                    </div>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['customer.phone'] !== '' &&
                  this.state.fieldsForSelectedBrand['customer.phone'] &&
                  this.state.fieldsForSelectedBrand['customer.phone'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12 col-md-3 col-lg-3  mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="customerPhone"
                      >
                        {t('partClaim.customerPhone')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand['customer.phone'] &&
                          this.state.fieldsForSelectedBrand[
                            'customer.phone'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors?.customerPhoneError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.customer.phone.trim() === '' &&
                              this.state.fieldsForSelectedBrand[
                                'customer.phone'
                              ][1] === 'required'
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="customer.phone"
                        type="text"
                        placeholder="xxx-xxx-xxxx"
                        value={formData.customer.phone}
                        onChange={this.handlecustomerphone}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.customerPhoneError
                          ? formData.customer.phone === '' &&
                            this.state.fieldsForSelectedBrand[
                              'customer.phone'
                            ][1] === 'required'
                            ? ` ${t('partClaim.reqfield')}`
                            : ` ${t('partClaim.phonerror')}`
                          : ''}
                      </span>
                    </div>
                  )}

                {this.state.fieldsForSelectedBrand &&
                  this.state.fieldsForSelectedBrand['customer.email'] !== '' &&
                  this.state.fieldsForSelectedBrand['customer.email'] &&
                  this.state.fieldsForSelectedBrand['customer.email'][0] ===
                    'true' && (
                    <div className="form-group col-sm-12 col-md-6 col-lg-6 mb">
                      <label
                        className="form-control-placeholder"
                        htmlFor="consumeremail"
                      >
                        {t('partClaim.consumeremail')}:
                        {this.state.fieldsForSelectedBrand &&
                          this.state.fieldsForSelectedBrand['customer.email'] &&
                          this.state.fieldsForSelectedBrand[
                            'customer.email'
                          ][1] === 'required' && (
                            <span className="required">*</span>
                          )}
                      </label>
                      <input
                        className={`form-control ${
                          this.state.errors?.consumerEmailError
                            ? 'is-invalid'
                            : this.state.formData.errormsgshow &&
                              formData.customer.email.trim() === '' &&
                              this.state.fieldsForSelectedBrand[
                                'customer.email'
                              ][1] === 'required'
                            ? 'form-control-error-border'
                            : ''
                        }`}
                        name="customer.consumeremail"
                        type="text"
                        value={formData.customer.email}
                        onChange={this.handleconsumeremail}
                      />

                      <span className="rp-warranty-input-error-internal">
                        {this.state.errors?.consumerEmailError ? (
                          formData.customer.email === '' &&
                          this.state.fieldsForSelectedBrand[
                            'customer.email'
                          ][1] === 'required' ? (
                            `${t('partClaim.reqfield')}`
                          ) : formData.customer.email.length > 50 &&
                            !emailcapsRegEx.test(formData.customer.email) ? (
                            <>
                              <p>{t('partClaim.emailexceederror')}</p>
                              <p>{t('partClaim.emailerror')}</p>
                            </>
                          ) : !emailcapsRegEx.test(formData.customer.email) ? (
                            `${t('partClaim.emailerror')}`
                          ) : formData.customer.email.length > 50 ? (
                            <>
                              <p>{t('partClaim.emailexceederror')}</p>
                            </>
                          ) : (
                            ''
                          )
                        ) : (
                          ''
                        )}
                      </span>
                    </div>
                  )}
              </div>
            )}
          {this.state.fieldsForSelectedBrand &&
            this.state.fieldsForSelectedBrand['emailServicer'] !== '' &&
            this.state.fieldsForSelectedBrand['emailServicer'] &&
            this.state.fieldsForSelectedBrand['emailServicer'][0] ===
              'true' && (
              <ServiceInfofields
                fieldstoshow={this.state.fieldsForSelectedBrand}
                email={this.state.formData.customer.servicerEmail}
                phonenumber={this.state.formData.customer.servicerPhone}
                errorlist={this.state.errors}
                errorshowmsg={this.state.formData.errormsgshow}
                handleEmailChange={this.handleserviceremail}
                handlePhonenumberChange={this.handleservicerphone}
              />
            )}
          {this.state.fieldsForSelectedBrand &&
            this.state.fieldsForSelectedBrand['part.partNumber'] !== '' &&
            this.state.fieldsForSelectedBrand['part.partNumber'] &&
            this.state.fieldsForSelectedBrand['part.partNumber'][0] ===
              'true' && (
              <div className="data-row buttons">
                <Button variant="contained" onClick={this.submitClaim} disabled={this.state.isSubmitButtonDisabled}>
                  {t('partClaim.submitClaim')}
                </Button>
              {this.state.isSubmitButtonDisabled &&
              <HalfCircleSpinner
                color="#0b4da2"
                size={30}
                style={{
                  textAlign: 'center',
                  display: 'inline-block',
                  padding: '5px'
                }}
              />
              }
              </div>
            )}
        </form>
      </>
    );
  }
}

export default WarrantyClaimForm;

export interface IOption {
  label: string;
  value: string | number;
}
interface IYesno {
  name: string;
  value: string;
  label: string;
}
interface IProductList {
  name: string;
  value: string;
  label: string;
}

export interface ILoption {
  label: string;
  value: string | number;
}
export const yesno: IYesno[] = [
  { name: 'Yes', value: 'Y', label: 'Y' },
  { name: 'No', value: 'N', label: 'N' }
];
export const productList: IProductList[] = [
  {
    name: 'Tankless Water Heater',
    value: 'Tankless Water Heater',
    label: 'Tankless Water Heater'
  },
  {
    name: 'Condensing Boiler',
    value: 'Condensing Boiler',
    label: 'Condensing Boiler'
  },
  { name: 'Direct Vent', value: 'Direct Vent', label: 'Direct Vent' }
];
interface IPartDetails {
  partNumber: string;
  quantity: number;
  price: number;
  unitpricenum: number;
  replacementInvNo: string;
  invoiceNumber: number;
  orgpurchasedate?: string;
  reppurchasedate?: string;
  tempquantity: number;
  priceshow: string;
  totalprice: string;
  unitprice: string;
  deletepic?: boolean;
  quantityshow?: string;
  funentrycount?: number;
  open?: boolean;
  maxsize?: boolean;
  imagetype?: boolean;
  loadingerror?: boolean;
  partReplacementDate?: moment.Moment;
  picofpart?: any[];
  fileArray?: any[];
  fileobject: any[];
  tempfilearray?: any[];
  uploadedfile?: any[];
  imagepreview?: any[];
  indexImage: number;
  showUploadModal?: boolean;
  spinner: boolean;
  count: number;
  testpartnum: string;
  mfg: string;
  wholePartNumber: string;

  pictureofpartstemp?: IPictureofpartstemp[];
  pictureofparts?: IPictureofparts[];
  isPartNumberInvalid?: boolean;
  partSelectedDetails?: IPartSelectedDetails[];
  partInvoiceList?: ISelectOption[];
  partInvoiceListtemp?: ISelectOptiontemp[];
  partInvoiceShow?: ISelectshowOption[];
  InvoiceOption?: ISelectOption;
}
interface IPictureofparts {
  filename: string;
  file: any[];
  spinner: string;
  imagecount: number;
  imgfail?: string;
  imgthumbnail?: string;
}
interface IPictureofpartstemp {
  filename: string;
  file: any[];
  spinner: string;
  imagecount: number;
  imgfail?: string;
  imgthumbnail?: string;
}
interface IPartSelectedDetails {
  partNumber: string;

  availableQuantity: number;
  unitPrice: number;

  invoiceNumber: string;
  purchaseDate: string;
  manufacturerCode: string;
  invoiceDate: string;
  wholePartNumber: string;
}

export interface IWarrantyClaimFormProps {
  t: any;
  claimNumber: string;
  userAccounts: IAccount[];
  onSuccess(): void;
  onFailed(message: string, statusObj?: any): void;

  userData: UserModel;
  cResubmitDetails: ClaimPartDetails;
  RSClaimDetails: CSPFailedDetails;
}

interface IWarrantyClaimFormState {
  formData: {
    accountNumber: string;
    accountName: string;
    brand: string;
    claimNumber: string;
    incidentNumber: string;
    modelNumber: string;
    serialNumber: string;
    partNumber: string; // start mine
    customerNumber: string;
    servicePerformed: string;
    orginvoiceNumber: string;
    replacementInvNo: string;
    partprice: string;
    trackinglocation: string;
    quantity: string;
    haveureturnpart: string;
    trackingnum: string;
    refno: string;
    purchasecost: string;
    picofpart: string;
    errormsg: string;
    errormsgshow: boolean;
    reset: boolean;
    modellist: boolean;
    producttype: string;
    reqreturn: string;
    supplierinvnum: string;
    supplierordernum: string;
    supplierponum: string;
    picurl: string;
    stateCode: string;

    ModelnumberList: [];
    ModelnumberSelected: IModellist[]; // end mine
    customer: {
      address: string;
      city: string;
      postalcode: string; //  mine
      number: string; //  mine
      zipCode: string;
      country: string;
      firstName: string;
      lastName: string;
      servicerEmail: string;
      servicerPhone: string;
      email: string; //  mine
      phone: string;
      state: string;
    };
    partInstalledDate: moment.Moment;
    partcallReceivedDate: moment.Moment;
    partFailedDate: moment.Moment;
    partRepairDate: moment.Moment;
    partPurchaseDate: moment.Moment;
    partsupplierinvdate: moment.Moment;

    customerComplaint: string;

    warrantyClaimDetails: IPartDetails[];
    showUploadModal: boolean;
    uploadsuccess: boolean;
    otherstate: boolean;
    finalsubmit: boolean;
    picloading: boolean;
    picfailed: boolean;
  };
  image: {
    open: boolean;
    files: [];
  };
  component: {
    formValidated: boolean;
    fieldsFailed: string[];
  };
  brandSelect: IBrand[];
  selectedState: IAddress;
  selectedtrackinglocation: ILocation;
  selectedproducttag: IProductList;
  selectedreturntag: IYesno;
  selectedhavureturn: IYesno;
  brandMapingList: [];
  fieldsForSelectedBrand: object;
  selectedBrand: IBrand;

  errors?: IFormErrors;
  isSubmitButtonDisabled:boolean;
  claimType:string;
}
interface ISelectOption {
  value: any;
  label: any;
  invnum: any;
  isDisabled: boolean;
  quantity?: any;
  unitPrice?: any;
}
interface IModellist {
  value: any;
  label: any;
}
interface ISelectOptiontemp {
  value: any;
  label: any;
  invnum: any;
}
interface ISelectshowOption {
  value: any;
  label: string;
}

interface IBrand {
  value: any;
  label: string;
}

interface IAccount {
  accountId: string;
  name: string;
  email: string;
}

interface IFormErrors {
  servicerEmailError: boolean;
  customerPhoneError: boolean;
  partInstalledDateError: boolean;
  partcallReceivedDateError: boolean;
  partFailDateError: boolean;
  partRepairDateError: boolean; // mine
  partPurchaseDateError: boolean;

  partsDetailsInvalidList: any[];
  accountNumberInvalidError: boolean;
  customerComplaintInvalidError: boolean;
  trackingNumberInvalidError: boolean;
  customerNumberError: boolean; // start mine
  supplierinvnumInvalidError: boolean;
  supplierordernumInvalidError: boolean;
  ReturnpartinvalidError: boolean;
  trackinglocationInvalidError: boolean;
  purchasecostInvalidError: boolean;
  supplierpoInvalidError: boolean;
  consumerprovinceError: boolean;
  picofpartInvalidError: boolean;
  claimNumberInvalidError: boolean;
  partNumberInvalidError: boolean;
  modelNumberInvalidError: boolean;
  serialNumberInvalidError: boolean;
  servicePerformedInvalidError: boolean;
  customerFirstNameInvalidError: boolean;
  customerLastNameInvalidError: boolean;
  orginvoiceNumberInvalidError: boolean;
  RepinvNumberInvalidError: boolean;
  consumerEmailError: boolean;
  consumerpostalcodeInvalidError: boolean;
  partpriceInvalidError: boolean;
  quantityInvalidError: boolean;
  refnoInvalidError: boolean;
  stateInvaliderror: boolean;
  reqforreturnInvalidError: boolean;
  servicerphoneError: boolean;
  customeraddressInvalidError: boolean;
  customercityInvalidError: boolean;
  customerstateInvalidError: boolean;
  haveureturnInvalidError: boolean;
  reqreturnInvalidError: boolean;
  producttypeInvalidError: boolean;
  incidentNumberInvalidError: boolean;
}

function FormErrors() {
  return {
    servicerEmailError: false,
    customerPhoneError: false,
    partInstalledDateError: false,
    partcallReceivedDateError: false,
    partFailDateError: false,
    partRepairDateError: false,
    partPurchaseDateError: false,
    partsDetailsInvalidList: new Array(),
    accountNumberInvalidError: false,
    customerComplaintInvalidError: false,
    //  mine
    trackingNumberInvalidError: false,
    customerNumberError: false,
    supplierordernumInvalidError: false,
    purchasecostInvalidError: false,
    picofpartInvalidError: false,
    claimNumberInvalidError: false,
    partNumberInvalidError: false,
    modelNumberInvalidError: false,
    serialNumberInvalidError: false,
    supplierpoInvalidError: false,
    supplierinvnumInvalidError: false,
    servicePerformedInvalidError: false,
    customerFirstNameInvalidError: false,
    customerLastNameInvalidError: false,
    orginvoiceNumberInvalidError: false,
    RepinvNumberInvalidError: false,
    consumerEmailError: false,
    consumerprovinceError: false,
    ReturnpartinvalidError: false,
    trackinglocationInvalidError: false,
    consumerpostalcodeInvalidError: false,
    partpriceInvalidError: false,
    quantityInvalidError: false,
    refnoInvalidError: false,
    stateInvaliderror: false,
    reqforreturnInvalidError: false,
    servicerphoneError: false,
    customeraddressInvalidError: false,
    customercityInvalidError: false,
    customerstateInvalidError: false,
    haveureturnInvalidError: false,
    reqreturnInvalidError: false,
    producttypeInvalidError: false
  };
}
